<template>
  <div>
    <div v-if="notLoaded">
      <h4>موفق به بارگذاری صفحه نبودیم، لطفا دوباره تلاش کنید.</h4>
    </div>
    <!-- NOTE (TEMPLATE) to getting informations & commitments to complete and sending proposal as a complete proposal  -->
    <div v-if="pageLoaded" class="animated fadeIn">
      <!-- we put reactivity data in template for vue reactivity problem with jsons -->
      <span v-show="false">{{ reactivity }}</span>
      <!-- loading component -->
      <Loading />
      <b-alert
        v-model="showTop"
        class="position-fixed fixed-top m-0 mt-9 rounded-0 bg-purple text-white text-center border-0"
        style="z-index: 2000; opacity: 60%"
        dir="rtl"
      >
        پیشنویس ثبت شد!
      </b-alert>
      <b-card
        v-if="
          $router.currentRoute.path.indexOf('/researcher/completeProposal/') ==
          0
        "
        style="border: 0"
        class="mt-0 mb-0"
      >
        <b-card
          v-if="
            (proposal.status == 'نیاز به تکمیل / اصلاح' ||
              proposal.status == 'پیش نویس') &&
            proposal.adminMessage
          "
          header-bg-variant="danger"
          header-text-variant="white"
          header="اصلاحات مورد نیاز"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ proposal.adminMessage }}</b-card
        >

        <b-tabs pills fill vertical v-model="tabIndex">
          <div class="d-flex justify-content-center mt-3">
            <!-- NOTE (b-previousTab) to go to the previous tab -->
            <b-button
              v-if="tabIndex != 0"
              class="mx-1"
              variant="light"
              @click="changePage('back')"
              >مرحله قبل</b-button
            >
            <!-- NOTE (b-saveDraft) to save draft -->
            <b-button
              :disabled="isSaving"
              class="mx-1"
              variant="success"
              @click="saveDraft()"
              >ثبت پیشنویس</b-button
            >
            <!-- NOTE (b-nextTab) to go to the next tab -->
            <b-button
              v-if="tabIndex != 11"
              class="mx-1"
              variant="primary"
              @click="changePage('next')"
              >مرحله بعد</b-button
            >
          </div>
          <b-tab :title="'عنوان و حمایت‌های پیشین'" active>
            <h3>پژوهشگر گرامی</h3>

            <b-form-group>
              <div class="d-flex" dir="ltr">
                <label
                  for="switch_1"
                  :class="
                    proposal.initialObligation
                      ? 'ml-3 mb-0 done'
                      : 'ml-3 mb-0 required'
                  "
                >
                  اینجانب تعهد می کنم با مطالعه و آگاهی از
                  <b-button
                    id="downLoad"
                    title="دانلود تعهدات"
                    variant="link"
                    :href="
                      filePath +
                      `/setad/private/15958532032483*H1%20'D9ED%20-E'%EF%BF%BD*%20'2%2071-G'%EF%BF%BD%20*-B%EF%BF%BDB'*%EF%BF%BD%20.pdf`
                    "
                  >
                    <b-tooltip
                      placement="bottomleft"
                      target="downLoad"
                      triggers="hover"
                      variant="info"
                      >دانلود شیوه‌نامه</b-tooltip
                    >شیوه‌نامه حمایت از طرح‌های پژوهشی ستاد توسعه زیست فناوری </b-button
                  >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در
                  سامانه اقدام می نمایم
                </label>
                <b-form-checkbox
                  disabled
                  id="switch_1"
                  class="ml-2 mr-n2"
                  v-model="proposal.initialObligation"
                ></b-form-checkbox>
              </div>
            </b-form-group>

            <p>
              به ابزار ثبت طرح سامانه تقسیم کار ملی خوش آمدید. خواهشندیم ابتدا
              به سوالات زیر پاسخ دهید:
            </p>
            <b-form-group
              label="لطفا عنوان پیشنهادی طرح را به زبان فارسی بنویسید (حداکثر 20 کلمه)"
              :class="proposal.faSubject ? 'done' : 'required'"
            >
              <b-form-input
                trim
                type="text"
                v-model="proposal.faSubject"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
              :class="
                proposal.initialIsSupported !== null ? 'done' : 'required'
              "
            >
              <b-form-radio-group v-model="proposal.initialIsSupported">
                <b-form-radio :value="true">بله</b-form-radio>
                <b-form-radio :value="false">خیر</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              label="حمایت ها:"
              v-if="proposal.initialIsSupported"
              :class="proposal.initialSupportedType ? 'done' : 'required'"
            >
              <b-form-select
                class="myselect2"
                id="first"
                v-model="proposal.initialSupportedType"
                :options="options"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group
              label="عنوان حمایت دریافتی"
              v-if="
                proposal.initialSupportedType == 'other' &&
                proposal.initialIsSupported
              "
              :class="proposal.initialOtherSupport ? 'done' : 'required'"
            >
              <b-form-input
                trim
                type="text"
                v-model="proposal.initialOtherSupport"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group
              label="توضیحات حمایت دریافتی:"
              v-if="proposal.initialIsSupported"
              :class="proposal.initialSupportDescription ? 'done' : 'required'"
            >
              <b-form-textarea
                trim
                rows="6"
                v-model="proposal.initialSupportDescription"
              >
              </b-form-textarea>
            </b-form-group>
          </b-tab>
          <b-tab :title="' اطلاعات اصلی طرح (' + step1progress + '%)'" active>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات اصلی طرح</h4>
              </template>
              <b-form-group
                label="عنوان به زبان فارسی (حداکثر 20 کلمه)"
                :class="proposal.faSubject ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.faSubject"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-row style="font-size: 12px" class="mb-2">
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                  aria-hidden="true"
                  style="font-size: 18px"
                ></i>
                <p class="text-danger ml-1">
                  جهت ویرایش این فیلد به بخش عنوان و حمایت های پیشین مراجعه کنید
                </p>
              </b-row>
              <b-form-group
                label="عنوان به زبان انگلیسی"
                :class="proposal.enSubject ? 'done' : 'required'"
              >
                <b-form-input
                  trim
                  type="text"
                  dir="ltr"
                  v-model="proposal.enSubject"
                  @keydown="nameKeydown($event)"
                ></b-form-input>
              </b-form-group>
              <hr />
              <b-row class="mb-2">
                <b-col>
                  <span
                    :class="
                      proposal.universityId
                        ? proposal.universityId != notUniversity
                          ? 'done'
                          : proposal.otherUniversity
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                    >دانشگاه محل اجرای طرح</span
                  >
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="proposal.universityId"
                    name="checkbox-1"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="
                      reactivity = !reactivity;
                      proposal.mehvarId = '';
                    "
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    :class="
                      proposal.universityId
                        ? proposal.universityId != notUniversity
                          ? 'done'
                          : proposal.otherUniversity
                          ? 'done'
                          : 'required'
                        : 'required'
                    "
                  >
                    <Select2
                      v-model="proposal.universityId"
                      :options="universities"
                      :settings="{ width: '100%' }"
                      @change="removeMehvar()"
                      :disabled="proposal.universityId == notUniversity"
                    ></Select2>
                    <b-form-input
                      trim
                      class="mt-1"
                      v-model="proposal.otherUniversity"
                      v-show="proposal.universityId == notUniversity"
                      placeholder="نام دانشگاه مورد نظر"
                      @input="reactivity = !reactivity"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>

              <!--Tooltip usage full here https://bootstrap-vue.org/docs/directives/tooltip ::::::::::::: v-b-tooltip.hover.left title="متن توضیحی"-->
              <b-form-group
                :disabled="!proposal.universityId"
                label="محور طرح (لطفا یک گزینه را انتخاب کنید)"
                :class="
                  proposal.mehvarId
                    ? proposal.mehvarId != notMehvar
                      ? 'done'
                      : proposal.otherMehvars
                      ? 'done'
                      : 'required'
                    : 'required'
                "
              >
                <b-list-group>
                  <b-list-group-item
                    style="cursor: pointer"
                    v-for="(mehvar, index) in computedMehvars"
                    :variant="selectedMehvar == index ? 'info' : 'light'"
                    :key="index"
                    @click="
                      proposal.mehvarId = mehvar.id;
                      selectedMehvar = index;
                    "
                    :disabled="mehvar.id == 0"
                  >
                    <span v-if="selectedMehvar == index">
                      <i class="fa fa-check-circle text-success"></i>
                    </span>
                    <span v-else>
                      <i class="fa fa-circle"></i>
                    </span>
                    {{ mehvar ? mehvar.text : "-" }}
                  </b-list-group-item>
                </b-list-group>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.otherMehvars"
                  v-show="
                    proposal.mehvarId == notMehvar ||
                    proposal.universityId == notUniversity
                  "
                  placeholder="نام محور مورد نظر"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="ماهیت طرح"
                :class="
                  proposal.typeStudy ||
                  proposal.typeSystemicDevelopmental ||
                  proposal.typePractical
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox
                  class="c-dark mt-3"
                  v-model="proposal.typeStudy"
                  >مطالعاتی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-dark mt-3"
                  v-model="proposal.typeSystemicDevelopmental"
                  >سیستمی و توسعه‌ای</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-dark mt-3"
                  v-model="proposal.typePractical"
                  >کاربردی</b-form-checkbox
                >
              </b-form-group>

              <b-form-group
                label="حوزه طرح"
                :class="
                  proposal.zoneMedicine ||
                  proposal.zoneAgriculture ||
                  proposal.zoneEnvironment ||
                  proposal.zoneIndustrial ||
                  proposal.zoneBioComputing ||
                  proposal.zoneOther
                    ? 'done'
                    : 'required'
                "
              >
                <b-form-checkbox
                  class="c-dark mt-3"
                  v-model="proposal.zoneMedicine"
                  >پزشکی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-dark mt-3"
                  v-model="proposal.zoneAgriculture"
                  >کشاورزی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-dark mt-3"
                  v-model="proposal.zoneEnvironment"
                  >محیط زیست</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-dark mt-3"
                  v-model="proposal.zoneIndustrial"
                  >صنعتی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-dark mt-3"
                  v-model="proposal.zoneBioComputing"
                  >رایانش زیستی</b-form-checkbox
                >
                <b-form-checkbox
                  class="c-dark mt-3"
                  v-model="proposal.zoneOther"
                  >سایر</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="' مجری طرح (' + step2progress + '%)'">
            <b-card class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات مجری طرح</h4>
              </template>
              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherName ? 'done' : 'required'"
                description
                label="نام:"
              >
                <b-form-input
                  trim
                  v-model="proposal.researcherName"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherLastName ? 'done' : 'required'"
                description
                label="نام خانوادگی:"
              >
                <b-form-input
                  trim
                  v-model="proposal.researcherLastName"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                :class="
                  isIdClass(proposal.researcherNatCode) ? 'done' : 'required'
                "
                description
                label="کدملی:"
              >
                <b-form-input
                  trim
                  type="number"
                  :no-wheel="true"
                  v-model="proposal.researcherNatCode"
                  aria-describedby="input-1-live-feedback"
                  :state="isID(proposal.researcherNatCode)"
                ></b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >کد ملی درست نیست</b-form-invalid-feedback
                >
              </b-form-group>
              <b-row>
                <b-col :cols="proposal.researcherMobile ? '12' : '10'">
                  <b-form-group
                    id="fieldset-horizontal"
                    :class="proposal.researcherMobile ? 'done' : 'required'"
                    description
                    label="تلفن همراه:"
                  >
                    <b-form-input
                      trim
                      disabled
                      v-model="proposal.researcherMobile"
                    ></b-form-input>
                    <b-row style="font-size: 12px" class="mt-1">
                      <i
                        class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                        aria-hidden="true"
                        style="font-size: 18px"
                      ></i>
                      <p class="text-danger ml-2">
                        شماره تلفن همراه شما قابل ویرایش نمی‌باشد
                      </p>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col v-if="!proposal.researcherMobile" class="pt-1" cols="2">
                  <b-button
                    class="mt-4"
                    variant="primary"
                    :disabled="gettingMobile"
                    @click="getMobile"
                    ><i class="fa fa-refresh" aria-hidden="true"></i
                  ></b-button>
                </b-col>
              </b-row>

              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherFax ? 'done' : 'required'"
                description
                label="دورنگار:"
              >
                <b-form-input
                  trim
                  v-model="proposal.researcherFax"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                :class="
                  isEmailClass(proposal.researcherEmail) ? 'done' : 'required'
                "
                description
                label="پست الکترونیکی:"
              >
                <b-form-input
                  trim
                  :state="isEmail(proposal.researcherEmail)"
                  aria-describedby="input-1-live-feedback"
                  v-model="proposal.researcherEmail"
                ></b-form-input>
                <b-form-invalid-feedback id="input-1-live-feedback"
                  >پست الکترونیکی درست نیست</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherStateId ? 'done' : 'required'"
                description
                label="استان:"
              >
                <!-- <b-form-input trim v-model="proposal.state"></b-form-input> -->
                <v-autocomplete
                  v-model="proposal.researcherStateId"
                  :items="iran"
                  @change="
                    proposal.researcherCityId = '';
                    proposal.researcherState = iran.filter(
                      (x) => x.id == proposal.researcherStateId
                    )[0].name;
                  "
                  item-value="id"
                  item-text="name"
                  dense
                  outlined
                  class="dropdown-style"
                  hide-details
                ></v-autocomplete>
              </b-form-group>
              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherCityId ? 'done' : 'required'"
                description
                label="شهر:"
              >
                <span v-show="false">{{ reactivity2 }}</span>
                <v-autocomplete
                  v-model="proposal.researcherCityId"
                  :items="
                    iran
                      .filter((x) => x.id == proposal.researcherStateId)
                      .map((y) => y.cities)[0]
                  "
                  item-value="id"
                  item-text="name"
                  dense
                  outlined
                  class="dropdown-style"
                  hide-details
                  @change="
                    reactivity2 = !reactivity2;
                    proposal.researcherCity = iran
                      .filter((x) => x.id == proposal.researcherStateId)[0]
                      .cities.filter(
                        (y) => y.id == proposal.researcherCityId
                      )[0].name;
                  "
                ></v-autocomplete>
              </b-form-group>
              <b-row class="my-2">
                <b-col>
                  <span :class="universityClass('researcher')"
                    >دانشگاه محل تحصیل:</span
                  >
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    v-model="proposal.researcherUniversityId"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="reactivity = !reactivity"
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group
                id="fieldset-horizontal"
                :class="universityClass"
                description
              >
                <Select2
                  class="myselect2"
                  v-model="proposal.researcherUniversityId"
                  :options="universities"
                  :settings="{ width: '100%' }"
                  @select="conditionalSelect($event, 'Eedu')"
                  :disabled="proposal.researcherUniversityId == notUniversity"
                ></Select2>
                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.researcherUniversityOther"
                  v-show="proposal.researcherUniversityId == notUniversity"
                  placeholder="نام دانشگاه"
                  @input="reactivity = !reactivity"
                ></b-form-input>
              </b-form-group>
              <b-row class="mb-2">
                <b-col>
                  <span>دانشگاه محل اشتغال به عنوان عضو هئیت علمی:</span>
                </b-col>
                <b-col class="text-left">
                  <b-form-checkbox
                    v-model="proposal.researcherUniversityJobId"
                    :value="notUniversity"
                    unchecked-value=""
                    @change="reactivity = !reactivity"
                  >
                    سایر دانشگاه ها
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-form-group id="fieldset-horizontal" description>
                <Select2
                  class="myselect2 mt-1"
                  v-model="proposal.researcherUniversityJobId"
                  :options="universities"
                  :settings="{ width: '100%' }"
                  @select="conditionalSelect($event, 'Ejob')"
                  :disabled="
                    proposal.researcherUniversityJobId == notUniversity
                  "
                ></Select2>

                <b-form-input
                  trim
                  class="mt-1"
                  v-model="proposal.researcherUniversityJobOther"
                  v-show="proposal.researcherUniversityJobId == notUniversity"
                  placeholder="نام دانشگاه"
                  @input="reactivity = !reactivity"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="fieldset-horizontal"
                :class="proposal.researcherLastDegree ? 'done' : 'required'"
                description
                label="آخرین مدرک تحصیلی:"
              >
                <b-form-select
                  v-model="proposal.researcherLastDegree"
                  :options="eduGradeOptions"
                  @select="conditionalSelect($event, 'Elast')"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                label="اهم فعالیت‌های تحقیقاتی پایان یافته و یا در حال اجراء و تألیفات در ارتباط مستقیم با موضوع طرح"
                :class="proposal.researcherResearch ? 'done' : 'required'"
              >
                <b-form-input trim v-model="proposal.researcherResearch" />
              </b-form-group>
              <b-form-group
                label="اهم فعالیت‌های صنعتی پایان یافته و یا در حال اجرا در ارتباط مستقیم با موضوع طرح"
                :class="proposal.researcherIndustry ? 'done' : 'required'"
              >
                <b-form-input trim v-model="proposal.researcherIndustry" />
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'همکاران طرح (' + step3progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">همکاران طرح</h4>
              </template>

              <!-- NOTE (b-addColleague) to add a colleague to colleagues' list -->
              <b-button variant="primary" class="mb-3" @click="addColleague()"
                >افزودن همکار جدید</b-button
              >
              <br />
              (تعداد همکاران طرح: {{ proposal.colleagues.length }})
              <b-card
                no-body
                v-for="(colleague, index) in proposal.colleagues"
                :key="index"
                class="border-0 shadow-sm mt-4"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <!-- NOTE (b-deleteColleague) to remove a colleague from colleague list -->
                  <b-button block v-b-toggle="String(index)">
                    همکار شماره {{ index + 1 }}
                    <b-button
                      variant="danger"
                      @click="deleteColleague(index)"
                      style="float: left"
                      >حذف همکار</b-button
                    >
                  </b-button>
                </b-card-header>

                <b-collapse
                  :id="String(index)"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <b-form-group
                        label="نام"
                        :class="colleague.name ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="colleague.name"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="نام خانوادگی"
                        :class="colleague.lastName ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="colleague.lastName"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="تلفن همراه"
                        :class="colleague.mobile ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          type="number"
                          :no-wheel="true"
                          v-model="colleague.mobile"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="کدملی"
                        :class="
                          isIdClass(colleague.natCode) ? 'done' : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          type="text"
                          v-model="colleague.natCode"
                          aria-describedby="input-1-live-feedback"
                          :state="isID(colleague.natCode)"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >کد ملی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>
                      <b-form-group
                        label="پست الکترونیکی"
                        :class="
                          isEmailClass(colleague.email) ? 'done' : 'required'
                        "
                      >
                        <b-form-input
                          trim
                          :state="isEmail(colleague.email)"
                          aria-describedby="input-1-live-feedback"
                          type="text"
                          v-model="colleague.email"
                        ></b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback"
                          >پست الکترونیکی درست نیست</b-form-invalid-feedback
                        >
                      </b-form-group>
                      <b-form-group
                        label="سمت"
                        :class="colleague.position ? 'done' : 'required'"
                      >
                        <b-form-input
                          trim
                          v-model="colleague.position"
                          type="text"
                        ></b-form-input>
                      </b-form-group>
                      <b-row class="mb-2">
                        <b-col>
                          <span
                            :class="
                              colleague.universityId
                                ? colleague.universityId != notUniversity
                                  ? 'done'
                                  : colleague.universityOther
                                  ? 'done'
                                  : 'required'
                                : 'required'
                            "
                            >دانشگاه محل تحصیل:</span
                          >
                        </b-col>
                        <b-col class="text-left">
                          <b-form-checkbox
                            v-model="colleague.universityId"
                            :value="notUniversity"
                            unchecked-value=""
                            @change="reactivity = !reactivity"
                          >
                            سایر دانشگاه ها
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-form-group
                        :class="
                          colleague.universityId
                            ? colleague.universityId != notUniversity
                              ? 'done'
                              : colleague.universityOther
                              ? 'done'
                              : 'required'
                            : 'required'
                        "
                      >
                        <Select2
                          v-model="colleague.universityId"
                          :options="universities"
                          :settings="{ width: '100%' }"
                          @select="conditionalSelect($event, 'Cedu')"
                          :disabled="colleague.universityId == notUniversity"
                        ></Select2>
                        <b-form-input
                          trim
                          class="mt-1"
                          v-model="colleague.universityOther"
                          v-show="colleague.universityId == notUniversity"
                          placeholder="نام دانشگاه"
                          @input="reactivity = !reactivity"
                        ></b-form-input>
                      </b-form-group>
                      <b-row class="mb-2">
                        <b-col>
                          <span>دانشگاه محل اشتغال به عنوان عضوهئیت علمی:</span>
                        </b-col>
                        <b-col class="text-left">
                          <b-form-checkbox
                            v-model="colleague.universityJobId"
                            :value="notUniversity"
                            unchecked-value=""
                            @change="reactivity = !reactivity"
                          >
                            سایر دانشگاه ها
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                      <b-form-group>
                        <Select2
                          v-model="colleague.universityJobId"
                          :options="universities"
                          :settings="{ width: '100%' }"
                          @select="conditionalSelect($event, 'Cedu')"
                          :disabled="colleague.universityJobId == notUniversity"
                        ></Select2>
                        <b-form-input
                          trim
                          class="mt-1"
                          v-model="colleague.universityJobOther"
                          v-show="colleague.universityJobId == notUniversity"
                          placeholder="نام دانشگاه"
                          @input="reactivity = !reactivity"
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="آخرین مدرک تحصیلی"
                        :class="colleague.lastDegree ? 'done' : 'required'"
                      >
                        <b-form-select
                          v-model="colleague.lastDegree"
                          :options="eduGradeOptions"
                          @select="conditionalSelect($event, 'Clast')"
                        ></b-form-select>
                      </b-form-group>
                      <b-form-group
                        label="رزومه سوابق علمی، تخصصی،و تحقیقاتی "
                        :class="colleague.resumeFileId ? 'done' : 'required'"
                      >
                        <b-form-file
                          :state="Boolean(colleague.resumeFile)"
                          :disabled="Boolean(colleague.resumeFile)"
                          @input="colUploadFile(colleague.file, index)"
                          v-model="colleague.file"
                          browse-text="بارگذاری"
                          :placeholder="
                            colleague.resumeFile
                              ? 'رزومه سوابق علمی، تخصصی،و تحقیقاتی'
                              : ' (حداکثر ۵ مگابایت)'
                          "
                        ></b-form-file>
                      </b-form-group>
                      <b-form-group>
                        <b-col>
                          <b-row></b-row>
                          <br />
                          <b-progress
                            v-if="colleague.showProgress"
                            :value="colleague.uploadPercentage"
                            :max="max"
                            show-progress
                            :animated="colleague.striped"
                            :variant="colleague.variant"
                          ></b-progress
                          ><br />
                          <b-row>
                            <b-col>
                              <b-row>
                                <div
                                  v-if="colleague.isUploaded"
                                  style="color: green"
                                  color="green"
                                  class="mt-3"
                                >
                                  فایل با موفقیت بارگذاری شد.
                                </div>
                              </b-row>
                            </b-col>
                            <b-col>
                              <b-row align-h="end">
                                <span class="mt-3 ml-2" style="float: left"
                                  ><a
                                    class="btn btn-success white--text"
                                    v-if="colleague.resumeFile"
                                    :href="colleague.resumeFile"
                                    target="_blank"
                                    >دریافت</a
                                  ></span
                                >
                                <b-button
                                  style="height: 35px; float: left"
                                  class="btn ml-2 mt-3"
                                  v-if="colleague.resumeFile"
                                  variant="danger"
                                  @click="
                                    colleague.file = null;
                                    colleague.resumeFile = '';
                                    colleague.resumeFileId = '';
                                    colleague.isUploaded = false;
                                    colleague.uploadPercentage = 0;
                                  "
                                  >حذف</b-button
                                >
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-form-group>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-card>
          </b-tab>
          <b-tab :title="'مشخصات طرح(' + step4progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">مشخصات طرح</h4>
              </template>

              <b-form-group
                label="چکیده طرح (200 تا 500 کلمه)"
                :class="
                  proposal.abstract
                    ? proposal.abstract.split(' ').length < 200 ||
                      proposal.abstract.split(' ').length > 500
                      ? 'required'
                      : 'done'
                    : 'required'
                "
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.abstract"
                  max-rows="6"
                ></b-form-textarea>
                طول چکیده:
                {{
                  proposal.abstract
                    ? (chek = proposal.abstract.split(" ").length)
                    : 0
                }}
                کلمه
              </b-form-group>
              <b-form-group
                label="ضرورت اجرای طرح"
                v-b-tooltip.hover.left
                title="در جهت دستیابی به اهداف ستاد و یا راهبردها و اقدامات سند توسعه زیست فناوری"
                :class="proposal.requestNecessity ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.requestNecessity"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="اهداف کلان طرح"
                :class="proposal.majorGoals ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.majorGoals"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="اهداف خرد طرح"
                :class="proposal.minorGoals ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.minorGoals"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                label="اجرای این طرح چه مزایای دیگری ممکن است برای کشور ایجاد کند؟"
                :class="proposal.benefitsToCountry ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.benefitsToCountry"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>

              <b-form-group
                label="روش شناسی (متدولوژی) و مراحل انجام طرح"
                :class="proposal.methodology ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.methodology"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="عنوان دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا خدمات) حاصل از اجرای طرح:"
                :class="achievmentItemsClass"
              >
                <!-- NOTE (b-addAchievment) to add achievment to achievment items table -->
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addAchievment()"
                  >+</b-button
                >
                <!-- NOTE (t-achievmentItems) to show achievment and output of proposal  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.requestProducts"
                  :fields="achievmentFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delAchievment(data.index)"
                      >x</b-button
                    >
                  </template>

                  <template v-slot:cell(name)="data">
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </template>

                  <template v-slot:cell(amount)="data">
                    <b-form-input
                      trim
                      v-model="data.item.amount"
                      type="number"
                      :no-wheel="true"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </template>
                  <template v-slot:cell(fullfill)="data">
                    <b-form-input
                      trim
                      v-model="data.item.fullfill"
                      type="number"
                      :no-wheel="true"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </template>
                </b-table>
              </b-form-group>
              <b-form-group
                label="سابقه اجرائی یا طرح‌های مشابه در ایران یا خارج از كشور (با ذكر ماخذ):"
                :class="proposal.executionHistorySimilar ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  v-model="proposal.executionHistorySimilar"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="آیا شركای بین‌المللی در اجرای طرح در نظر گرفته شده است؟ چه كسانی هستند و چه نقشی در مدیریت و اجرای طرح دارند؟"
                :class="proposal.internationalPartners ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.internationalPartners"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="منابع و ماخذ"
                :class="proposal.references ? 'done' : 'required'"
              >
                <b-form-textarea
                  trim
                  type="text"
                  rows="6"
                  v-model="proposal.references"
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="' اطلاعات تجاری‌سازی \n(' + step5progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">اطلاعات تجاری‌سازی</h4>
              </template>

              <v-row
                class="p-1 mb-4 grey lighten-2"
                style="border: 1px solid #ccc; border-radius: 10px"
              >
                <v-col>
                  <p>گزینه مورد نظر را انتخاب کنید:</p>
                  <b-form-radio-group
                    v-model="proposal.commercializingType"
                    class="d-flex justify-space-between"
                  >
                    <b-form-radio value="company" class="ms-1"
                      >شرکت دانش بنیان</b-form-radio
                    >
                    <b-form-radio value="accelerator">شتاب‌دهنده</b-form-radio>
                    <b-form-radio value="none">
                      فاقد اطلاعات تجاری‌سازی هستم</b-form-radio
                    >
                  </b-form-radio-group>
                </v-col>
              </v-row>

              <div
                v-if="proposal.commercializingType == 'company'"
                class="mb-6"
              >
                <div class="text-left mb-6">
                  <v-btn @click="viewList('company')" class="btn-light"
                    ><span class="fs-xsmall"
                      ><v-icon class="me-1">mdi-table-of-contents</v-icon>مشاهده
                      لیست شرکت‌ها</span
                    ></v-btn
                  >
                </div>
                <v-row class="pb-1">
                  <v-col>
                    <span
                      :class="
                        proposal.companyId
                          ? proposal.companyId != notCompany
                            ? 'done'
                            : proposal.otherCompanyName
                            ? 'done'
                            : 'required'
                          : 'required'
                      "
                    >
                      نام شرکت دانش بنیان
                    </span>
                  </v-col>
                  <v-col class="text-left">
                    <b-form-checkbox
                      v-model="proposal.companyId"
                      :value="notCompany"
                      unchecked-value=""
                      @change="reactivity = !reactivity"
                    >
                      سایر شرکت ها
                    </b-form-checkbox>
                  </v-col>
                </v-row>
                <b-form-group
                  :class="
                    proposal.companyId
                      ? proposal.companyId != notCompany
                        ? 'done'
                        : proposal.otherCompanyName
                        ? 'done'
                        : 'required'
                      : 'required'
                  "
                >
                  <Select2
                    v-model="proposal.companyId"
                    :options="companies"
                    :settings="{ width: '100%' }"
                    :disabled="proposal.companyId == notCompany"
                    @change="getCompanyInfo()"
                  ></Select2>

                  <b-form-input
                    trim
                    class="mt-1"
                    v-model="proposal.otherCompanyName"
                    v-show="proposal.companyId == notCompany"
                    placeholder="نام شرکت مورد نظر"
                    @input="reactivity = !reactivity"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="شماره ثبت"
                  :class="computedTitle1 ? 'done' : 'required'"
                >
                  <div
                    v-if="
                      proposal.companyId && proposal.companyId != notCompany
                    "
                    class="readonly-box"
                  >
                    <span class="c-grey">{{
                      proposal.companyRegistrationNumber
                        ? proposal.companyRegistrationNumber
                        : "-"
                    }}</span>
                  </div>
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.otherCompanyRegistrationNumber"
                    v-else
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="شناسه ملی"
                  :class="computedTitle2 ? 'done' : 'required'"
                >
                  <div
                    v-if="
                      proposal.companyId && proposal.companyId != notCompany
                    "
                    class="readonly-box"
                  >
                    <span class="c-grey">{{
                      proposal.companyNationalId
                        ? proposal.companyNationalId
                        : "-"
                    }}</span>
                  </div>
                  <b-form-input
                    trim
                    type="text"
                    v-model="proposal.otherCompanyNationalId"
                    v-else
                    rows="6"
                    max-rows="6"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="معرفی فناوری یا محصولات شرکت:"
                  :class="proposal.companyProducts ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    v-model="proposal.companyProducts"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="آدرس پستی / شماره تماس/ پست الکترونیک شرکت:"
                  :class="proposal.companyContactInfo ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.companyContactInfo"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  :class="proposal.letterCompanyFile ? 'done' : 'required'"
                >
                  <b-row class="my-2" align-v="center">
                    <b-col align-self="end">
                      <h6>نامه صنعت یا شرکت</h6>
                    </b-col>
                    <b-col>
                      <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                      <a
                        :href="
                          filePath + `/setad/private/1613289974968company.doc`
                        "
                        class="btn btn-primary text-light"
                        target="_blank"
                        style="float: left"
                        >دانلود نمونه فایل</a
                      >
                    </b-col>
                  </b-row>
                  <b-form-file
                    :state="Boolean(proposal.letterCompanyFile)"
                    :disabled="Boolean(proposal.letterCompanyFile)"
                    @input="
                      uploadFile(uploadedFiles[0].file, 0, 'letterCompanyFile')
                    "
                    v-model="uploadedFiles[0].file"
                    browse-text="بارگذاری"
                    :placeholder="
                      files[0]
                        ? files[0].showName
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="uploadedFiles[0].uploadPercentage"
                      :value="uploadedFiles[0].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[0].striped"
                      :variant="uploadedFiles[0].variant"
                    ></b-progress
                    ><br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[0].isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row v-if="proposal.letterCompanyFile" align-h="end">
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="proposal.letterCompanyFile"
                              download="نامه صنعت یا شرکت"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(0, 'letterCompanyFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </div>
              <div
                v-else-if="proposal.commercializingType == 'accelerator'"
                class="mb-6"
              >
                <div class="text-left mb-6">
                  <v-btn @click="viewList('accelerator')" class="btn-light"
                    ><span class="fs-xsmall"
                      ><v-icon class="me-1">mdi-table-of-contents</v-icon>مشاهده
                      لیست شتاب‌دهنده‌ها</span
                    ></v-btn
                  >
                </div>
                <v-row class="pb-1">
                  <v-col>
                    <span :class="proposal.acceleratorId ? 'done' : 'required'"
                      >نام شتاب‌دهنده</span
                    >
                  </v-col>
                </v-row>
                <Select2
                  v-model="proposal.acceleratorId"
                  :options="accelerators"
                  :settings="{ width: '100%' }"
                ></Select2>
                <b-form-group>
                  <b-row class="my-2" align-v="center">
                    <b-col align-self="end">
                      <h6>نامه صنعت یا شرکت</h6>
                    </b-col>
                    <b-col>
                      <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                      <a
                        :href="
                          filePath + `/setad/private/1613289974968company.doc`
                        "
                        class="btn btn-primary text-light"
                        target="_blank"
                        style="float: left"
                        >دانلود نمونه فایل</a
                      >
                    </b-col>
                  </b-row>
                  <b-form-file
                    :disabled="Boolean(proposal.letterCompanyFile)"
                    @input="
                      uploadFile(uploadedFiles[0].file, 0, 'letterCompanyFile')
                    "
                    v-model="uploadedFiles[0].file"
                    browse-text="بارگذاری"
                    :placeholder="
                      files[0]
                        ? files[0].showName
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="uploadedFiles[0].uploadPercentage"
                      :value="uploadedFiles[0].uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="uploadedFiles[0].striped"
                      :variant="uploadedFiles[0].variant"
                    ></b-progress
                    ><br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="uploadedFiles[0].isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row v-if="proposal.letterCompanyFile" align-h="end">
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="proposal.letterCompanyFile"
                              download="نامه صنعت یا شرکت"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="delFile(0, 'letterCompanyFile')"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
              </div>
              <div
                v-else-if="proposal.commercializingType == 'none'"
                class="mb-6"
              >
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    v-model="proposal.commercializingObligation1"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox
                  ><span
                    class="ps-2"
                    :class="
                      proposal.commercializingObligation1 ? 'done' : 'required'
                    "
                  >
                    تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                    یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست
                    فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                  </span>
                </div>
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    v-model="proposal.commercializingObligation2"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox>
                  <span
                    class="ps-2"
                    :class="
                      proposal.commercializingObligation2 ? 'done' : 'required'
                    "
                  >
                    تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                    این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                    خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                    بررسی و تایید کنند.
                  </span>
                </div>
              </div>
              <b-card header-bg-variant="default" class="border-0 shadow-sm">
                <template v-slot:header>
                  <h4 class="mb-0">
                    ملاحظات مربوط به همکاری طرفین، بازار و عایدی طرح
                  </h4>
                </template>

                <b-form-group
                  label="نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق مالکیت:"
                  :class="
                    proposal.interactUniversityCenters ? 'done' : 'required'
                  "
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.interactUniversityCenters"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="معرفی بازار هدف:"
                  :class="proposal.targetMarket ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.targetMarket"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="پیش بینی میزان فروش محصول در سه سال اول:"
                  :class="proposal.productSalesForecast ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    v-model="proposal.productSalesForecast"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="میزان اشتغال زایی طرح:"
                  :class="proposal.employment ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    v-model="proposal.employment"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="برآورد مدت زمان همکاری:"
                  :class="proposal.durationCooperation ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    v-model="proposal.durationCooperation"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="برآورد میزان تولید و عایدی طرح:"
                  :class="
                    proposal.estimationProductionProjectRevenue
                      ? 'done'
                      : 'required'
                  "
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    max-rows="6"
                    v-model="proposal.estimationProductionProjectRevenue"
                  ></b-form-textarea>
                </b-form-group>

                <b-form-group
                  label="محصولات رقیب و میزان رقابت پذیری (مقایسه قیمت):"
                  :class="
                    proposal.competitiveProductsLevelCompetitiveness
                      ? 'done'
                      : 'required'
                  "
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    max-rows="6"
                    v-model="proposal.competitiveProductsLevelCompetitiveness"
                  ></b-form-textarea>
                </b-form-group>
                <b-form-group
                  label="مزیت محصول نسبت به موارد مشابه و موجود:"
                  :class="proposal.productAdvantages ? 'done' : 'required'"
                >
                  <b-form-textarea
                    trim
                    type="text"
                    rows="6"
                    max-rows="6"
                    v-model="proposal.productAdvantages"
                  ></b-form-textarea>
                </b-form-group>
              </b-card>
            </b-card>
          </b-tab>
          <b-tab :title="' زمان‌بندی(' + step6progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">شرح خدمات، زمان‌بندی و فازبندی طرح</h4>
              </template>

              <b-form-group>
                <!-- NOTE (b-addService) to add a row to service items table -->
                <b-button
                  variant="success"
                  class="mb-3 ml-1"
                  @click="addService()"
                  >+</b-button
                >
                <!-- NOTE (t-serviceItems) to show informations of phase scheduling, activities description and weight percentage of activity  -->
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="proposal.gantData"
                  :fields="serviceFields"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  <template v-slot:cell(report)="data">
                    <b-form-checkbox
                      :id="'tooltip-target-' + data.index"
                      v-model="data.item.report"
                    ></b-form-checkbox>
                    <b-tooltip
                      placement="top"
                      :show="myshow"
                      delay="100"
                      :target="'tooltip-target-' + data.index"
                      >درصورت ارائه گزارش در پایان این فاز به ستاد، انتخاب
                      نمایید</b-tooltip
                    >
                  </template>
                  <template v-slot:cell(cellColor)="data">
                    <div>
                      <ColourPicker
                        ref="colorPicker"
                        no-input
                        picker="compact"
                        :color="data.item.cellColor"
                        :value="data.item.cellColor"
                        v-model="data.item.cellColor"
                      />
                    </div>
                  </template>

                  <template v-slot:cell(operation)="data">
                    <div>
                      <!-- NOTE (b-delService) to remove a row from service items table -->
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delService(data.index)"
                      >
                        <i class="fa fa-times" />
                      </b-button>
                    </div>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.description"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>

                  <template v-slot:cell(percent)="data">
                    <div>
                      <b-form-input
                        trim
                        v-model="data.item.percent"
                        type="number"
                        :no-wheel="true"
                        min="0"
                        max="100"
                        :state="
                          data.item.percent >= 0 && data.item.percent <= 100
                        "
                      ></b-form-input>
                    </div>
                  </template>
                  <template v-slot:cell(startDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.startDate"
                        @change="changedStartDate(data.item, data.index)"
                      ></date-picker>
                    </div>
                  </template>
                  <template v-slot:cell(dueDate)="data">
                    <div>
                      <date-picker
                        color="#7b1fa2"
                        :auto-submit="true"
                        v-model="data.item.dueDate"
                        :min="computedMinDate(data.item.startDate)"
                      ></date-picker>
                    </div>
                  </template>
                </b-table>

                <sarmadGantt
                  :items="proposal.gantData"
                  :fields="serviceFields"
                />

                <p
                  :class="
                    proposal.gantData
                      .map((x) => x.percent)
                      .reduce((a, b) => Number(a) + Number(b), 0) == 100
                      ? 'done'
                      : 'required'
                  "
                >
                  توجه داشته باشید که مجموع درصد وزنی فعالیت باید 100 درصد باشد.
                  درصد فعلی:
                  {{
                    proposal.gantData.length == 0
                      ? 0
                      : proposal.gantData
                          .map((x) => x.percent)
                          .reduce((a, b) => Number(a) + Number(b), 0)
                  }}
                  %
                </p>
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="' هزینه‌ها(' + step7progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">هزینه‌های پرسنلی اعم از مجری و همكاران</h4>
              </template>

              <!-- NOTE (b-addCost) to add cost to costs table -->
              <b-button @click="addCost1()" variant="success" class="mb-3"
                >افزودن</b-button
              >

              <!-- NOTE (t-personnelCost) to show personnel costs with details about each personnel -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.personnelCosts"
                :fields="PersonnelCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                ],
                <template v-slot:cell(operation)="data">
                  <div>
                    <!-- NOTE (b-delCost) to remove a row from costs table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delCost1(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(name)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(degree)="data">
                  <div>
                    <b-form-select
                      v-model="data.item.degree"
                      :options="options1"
                    ></b-form-select>
                  </div>
                </template>
                <template v-slot:cell(cooperationType)="data">
                  <div>
                    <b-form-select
                      v-model="data.item.cooperationType"
                      :options="options2"
                    ></b-form-select>
                  </div>
                </template>
                <template v-slot:cell(cooperationHour)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.cooperationHour"
                      type="number"
                      :no-wheel="true"
                      rows="6"
                      max-rows="6"
                      min="0"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(perPersonCost)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.perPersonCost"
                      type="number"
                      :no-wheel="true"
                      rows="6"
                      max-rows="6"
                      min="0"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(humanResourceCost)="data">
                  <div>
                    {{
                      (
                        parseInt(data.item.perPersonCost) *
                        parseInt(data.item.cooperationHour)
                      ).toLocaleString()
                    }}
                  </div>
                </template>
              </b-table>
              جمع کل هزینه های پرسنلی:
              {{
                proposal.personnelCosts.length == 0
                  ? 0
                  : proposal.personnelCosts
                      .map(
                        (x) =>
                          parseInt(x.perPersonCost) *
                          parseInt(x.cooperationHour)
                      )
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
            </b-card>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">
                  هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا، حمل و
                  نقل، حق مأموریت و ...)
                </h4>
              </template>

              <!-- NOTE (b-addTripCost) to add a row to trip costs table -->
              <b-button @click="addTripCost()" variant="success" class="mb-3"
                >افزودن</b-button
              >

              <!-- NOTE (t-tripCost) to show trip costs with details about destination, purpose of trip,... -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.travelExpenses"
                :fields="tripCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                ],
                <template v-slot:cell(operation)="data">
                  <div>
                    <!-- NOTE (b-delTripCost) to remove a row on trip costs table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delTripCost(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(destination)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.destination"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(reason)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.reason"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(number)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.number"
                      type="number"
                      min="0"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(day)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.day"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(cost)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.cost"
                      type="number"
                      :no-wheel="true"
                      min="0"
                    ></b-form-input>
                  </div>
                </template>
              </b-table>
              جمع کل مسافرت‌های ضروری:
              {{
                proposal.travelExpenses.length == 0
                  ? 0
                  : proposal.travelExpenses
                      .map((x) => x.cost)
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
            </b-card>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">
                  هزینه دستگاه‌ها، وسایل و مواد مورد نیاز كه باید از محل اعتبار
                  طرح خریداری شوند
                </h4>
              </template>

              <!-- NOTE (b-addDeviceCost) to add device cost to device costs table -->
              <b-button @click="addDeviceCost()" variant="success" class="mb-3"
                >افزودن</b-button
              >

              <!-- NOTE (t-deviceCost) to show the cost of devices with details about each device -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.purchases"
                :fields="deviceCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(type)="data">
                  <div>
                    <b-form-select
                      v-model="data.item.type"
                      :options="deviceTypes"
                    ></b-form-select>
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div>
                    <!-- NOTE (b-delDeviceCost) to remove a row from device costs table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delDeviceCost(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(name)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(source)="data">
                  <div>
                    <b-form-select
                      v-model="data.item.source"
                      :options="sources"
                      style="min-width: 100px"
                    ></b-form-select>
                  </div>
                </template>
                <template v-slot:cell(number)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.number"
                      type="number"
                      min="0"
                      :no-wheel="true"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(perPrice)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.perPrice"
                      type="number"
                      min="0"
                      :no-wheel="true"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(totalPrice)="data">
                  <!-- <div>
                    <b-form-input trim v-model="data.item.totalPrice" type="number"  :no-wheel='true'></b-form-input>
                  </div>-->
                  <div>
                    {{
                      (
                        parseInt(data.item.number) *
                        parseInt(data.item.perPrice)
                      ).toLocaleString()
                    }}
                  </div>
                </template>
              </b-table>
              جمع کل هزینه دستگاه‌ها:
              {{
                proposal.purchases.length == 0
                  ? 0
                  : proposal.purchases
                      .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
            </b-card>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">میزان مشارکت سایر سازمان ها در بودجه طرح</h4>
              </template>

              <!-- NOTE (b-addOrgCost) to add organization cost to organization costs table -->
              <b-button @click="addOrgCost()" variant="success" class="mb-3"
                >افزودن</b-button
              >

              <!-- NOTE (t-orgCost) to show cost of cooperation with other organisations -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.participationOrganizationBudget"
                :fields="OrgCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary mb-2"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                ],
                <template v-slot:cell(operation)="data">
                  <div>
                    <!-- NOTE (b-delOrgCost) to remove a row from organization costs table -->
                    <b-button
                      variant="danger"
                      class="mr-2"
                      @click="delOrgCost(data.index)"
                      >x</b-button
                    >
                  </div>
                </template>

                <template v-slot:cell(name)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.name"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>

                <template v-slot:cell(description)="data">
                  <div>
                    <b-form-textarea
                      trim
                      v-model="data.item.description"
                    ></b-form-textarea>
                  </div>
                </template>

                <template v-slot:cell(totalPrice)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.totalPrice"
                      type="number"
                      min="0"
                      :no-wheel="true"
                    ></b-form-input>
                  </div>
                </template>
              </b-table>
              جمع کل مشارکت موسسات:
              {{
                proposal.participationOrganizationBudget.length == 0
                  ? 0
                  : proposal.participationOrganizationBudget
                      .map((x) => x.totalPrice)
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      .toLocaleString()
              }}
              تومان
              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3 mt-2"
                  aria-hidden="true"
                ></i>
                <p class="mt-3 ml-2">
                  اگر زیرساخت،تجهیزات و دستگاه مد نظر است مبلغ میزان مشارکت وارد
                  نشود ولی مراکزی که قرار است مشارکت کنند معرفی شوند.
                </p>
              </b-row>
            </b-card>
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">هزینه‌های دیگر:</h4>
              </template>
              <h5 class="my-4"></h5>

              <!-- NOTE (t-otherCost) to show any other cost with three default row  -->
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.otherCosts"
                :fields="otherCostField"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>

                <template v-slot:cell(totalPrice)="data">
                  <div>
                    <b-form-input
                      trim
                      v-model="data.item.totalPrice"
                      type="number"
                      min="0"
                      :no-wheel="true"
                    ></b-form-input>
                  </div>
                </template>
              </b-table>
              <p>
                جمع کل سایر هزینه‌ها:
                {{
                  proposal.otherCosts.length == 0
                    ? 0
                    : proposal.otherCosts
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                        .toLocaleString()
                }}
                تومان
              </p>
            </b-card>
            <h3>
              جمع کل هزینه‌ها:
              {{
                (tPrice = (
                  (proposal.personnelCosts.length == 0
                    ? 0
                    : proposal.personnelCosts
                        .map(
                          (x) =>
                            parseInt(x.perPersonCost) *
                            parseInt(x.cooperationHour)
                        )
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                  (proposal.travelExpenses.length == 0
                    ? 0
                    : proposal.travelExpenses
                        .map((x) => x.cost)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                  (proposal.purchases.length == 0
                    ? 0
                    : proposal.purchases
                        .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
                  (proposal.otherCosts.length == 0
                    ? 0
                    : proposal.otherCosts
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                ).toLocaleString())
              }}
              تومان
            </h3>
            <hr />
            <h3>
              میزان اعتبار مورد نیاز از ستاد زیست فناوری:
              {{ computedTotalCost.toLocaleString() }}
              تومان
            </h3>
          </b-tab>
          <b-tab :title="'داوران پیشنهادی(' + step8progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">داوران پیشنهادی</h4>
              </template>

              <!-- NOTE (b-addReviewer) to add reviewer to recommended reviewer field  -->
              <b-button variant="primary" class="mb-3" @click="addReviewer()"
                >افزودن داور جدید</b-button
              >
              <br />
              (تعداد داوران: {{ proposal.reviewers.length }})
              <b-card
                v-for="(reviewer, index) in proposal.reviewers"
                :key="index"
                class="border-0 shadow-sm mt-4"
              >
                <template v-slot:header>
                  <strong>داور شماره {{ index + 1 }}</strong>

                  <!-- NOTE (b-deleteReviewer) to remove reviewer from recommended reviewer field -->
                  <b-button
                    variant="danger"
                    @click="deleteReviewer(index)"
                    style="float: left"
                    >حذف داور</b-button
                  >
                </template>

                <b-form-group
                  label="نام"
                  :class="reviewer.name ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    type="text"
                    v-model="reviewer.name"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label="نام خانوادگی"
                  :class="reviewer.lastName ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    type="text"
                    v-model="reviewer.lastName"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label="حوزه کاری"
                  :class="reviewer.expertise ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    type="text"
                    v-model="reviewer.expertise"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label="رشته تحصیلی"
                  :class="reviewer.field ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    type="text"
                    v-model="reviewer.field"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  label="رتبه علمی"
                  :class="reviewer.academicRank ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    type="text"
                    v-model="reviewer.academicRank"
                  ></b-form-input>
                </b-form-group>

                <b-form-group
                  :class="reviewer.lastDegree ? 'done' : 'required'"
                  label="آخرین مدرک تحصیلی"
                >
                  <b-form-select
                    v-model="reviewer.lastDegree"
                    :options="eduGradeOptions"
                    @select="conditionalSelect($event, 'Rlast')"
                  ></b-form-select>
                </b-form-group>

                <b-form-group
                  label="پست الکترونیکی"
                  :class="isEmailClass(reviewer.email) ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    :state="isEmail(reviewer.email)"
                    aria-describedby="input-1-live-feedback"
                    type="text"
                    v-model="reviewer.email"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-1-live-feedback"
                    >پست الکترونیکی درست نیست</b-form-invalid-feedback
                  >
                </b-form-group>

                <b-form-group
                  label="شماره تماس"
                  :class="reviewer.mobile ? 'done' : 'required'"
                >
                  <b-form-input
                    trim
                    v-model="reviewer.mobile"
                    type="number"
                    :no-wheel="true"
                  ></b-form-input>
                </b-form-group>
              </b-card>
            </b-card>
          </b-tab>
          <b-tab :title="'فایل‌های تکمیلی(' + step9progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">فایل‌های تکمیلی</h4>
              </template>
              <b-form-group
                :class="
                  proposal.letterUniversityResearchFile ? 'done' : 'required'
                "
              >
                <b-row class="mb-2" align-v="center">
                  <b-col align-self="end">
                    <h6>نامه شورای پژوهش یا فناوری دانشگاه</h6>
                  </b-col>
                  <b-col>
                    <!-- NOTE (<a>) to download the sample file of university approval by opening a new page -->
                    <a
                      :href="
                        filePath +
                        `/setad/private/1613804042524pajoheshi_postDoc.doc`
                      "
                      class="btn btn-primary text-light"
                      target="_blank"
                      style="float: left"
                      >دانلود نمونه فایل</a
                    >
                  </b-col>
                </b-row>
                <b-form-file
                  :state="Boolean(proposal.letterUniversityResearchFile)"
                  :disabled="Boolean(proposal.letterUniversityResearchFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[0].file,
                      0,
                      'letterUniversityResearchFile'
                    )
                  "
                  v-model="uploadedFiles[0].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[0]
                      ? files[0].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[0].uploadPercentage"
                    :value="uploadedFiles[0].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[0].striped"
                    :variant="uploadedFiles[0].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[0].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.letterUniversityResearchFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.letterUniversityResearchFile"
                            download="نامه شورای پژوهش یا فناوری دانشگاه"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(0, 'letterUniversityResearchFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group
                label="توافقنامه دانشگاه با صنعت "
              >
                <b-form-file
                  :disabled="Boolean(proposal.universityAgreementIndustryFile)"
                  @input="
                    uploadFile(
                      uploadedFiles[1].file,
                      1,
                      'universityAgreementIndustryFile'
                    )
                  "
                  v-model="uploadedFiles[1].file"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[1]
                      ? files[1].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <p class="c-grey">
                * بارگذاری این نامه تاثیر مثبت در روند بررسی طرح خواهد داشت.
              </p>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[1].uploadPercentage"
                    :value="uploadedFiles[1].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[1].striped"
                    :variant="uploadedFiles[1].variant"
                  ></b-progress
                  ><br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[1].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        v-if="proposal.universityAgreementIndustryFile"
                        align-h="end"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.universityAgreementIndustryFile"
                            download="توافقنامه دانشگاه با صنعت"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(1, 'universityAgreementIndustryFile')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="سایر مدارک (1)">
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.otherFile1Title"
                  placeholder="عنوان فایل"
                ></b-form-input>
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.otherFile1Description"
                  placeholder="توضیحات"
                ></b-form-input>
                <b-form-file
                  @input="uploadFile(uploadedFiles[2].file, 2, 'otherFile1')"
                  v-model="uploadedFiles[2].file"
                  :disabled="Boolean(proposal.otherFile1)"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[2]
                      ? files[2].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[2].uploadPercentage"
                    :value="uploadedFiles[2].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[2].striped"
                    :variant="uploadedFiles[2].variant"
                  ></b-progress
                  ><br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[2].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile1" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.otherFile1"
                            download="سایر مدارک (1)"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(2, 'otherFile1')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="سایر مدارک (2)">
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.otherFile2Title"
                  placeholder="عنوان فایل"
                ></b-form-input>
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.otherFile2Description"
                  placeholder="توضیحات"
                ></b-form-input>
                <b-form-file
                  @input="uploadFile(uploadedFiles[3].file, 3, 'otherFile2')"
                  v-model="uploadedFiles[3].file"
                  :disabled="Boolean(proposal.otherFile2)"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[3]
                      ? files[3].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[3].uploadPercentage"
                    :value="uploadedFiles[3].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[3].striped"
                    :variant="uploadedFiles[3].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[3].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile2" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.otherFile2"
                            download="سایر مدارک (2)"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(3, 'others2')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <b-form-group label="سایر مدارک (3)">
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.otherFile3Title"
                  placeholder="عنوان فایل"
                ></b-form-input>
                <b-form-input
                  trim
                  type="text"
                  v-model="proposal.otherFile3Description"
                  placeholder="توضیحات"
                ></b-form-input>
                <b-form-file
                  @input="uploadFile(uploadedFiles[4].file, 4, 'otherFile3')"
                  v-model="uploadedFiles[4].file"
                  :disabled="Boolean(proposal.otherFile3)"
                  browse-text="بارگذاری"
                  :placeholder="
                    files[4]
                      ? files[4].showName
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>

              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="uploadedFiles[4].uploadPercentage"
                    :value="uploadedFiles[4].uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="uploadedFiles[4].striped"
                    :variant="uploadedFiles[4].variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="uploadedFiles[4].isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row v-if="proposal.otherFile3" align-h="end">
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="proposal.otherFile3"
                            download="سایر مدارک (3)"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          @click="delFile(4, 'otherFile3')"
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>

              <!-- NOTE (t-fileFields) to show uploded files and each file is downloadable  -->
              <b-table
                responsive
                show-empty
                head-variant="dark"
                :fields="fileFields"
                :items="files.filter((x) => x && x.url != '')"
                empty-text="فایلی وجود ندارد"
                striped
                :busy="fileBusy"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>

                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(url)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                    <a
                      v-if="data.value"
                      class="btn btn-success white--text"
                      :href="data.value"
                      target="_blank"
                      >دریافت فایل</a
                    >
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
          </b-tab>
          <b-tab :title="'تعهدات(' + step10progress + '%)'">
            <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <template v-slot:header>
                <h4 class="mb-0">تعهدات</h4>
              </template>

              <!-- <b-card header-bg-variant="default" class="border-0 shadow-sm">
              <h4 class="mb-0">&nbsp;</h4>-->
              <b-form-group>
                <b-form-checkbox
                  :class="proposal.promiseArrays[0] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[0]"
                >
                  این طرح در مدت زمان اعلام شده در پروپوزال انجام می‌گردد و
                  مسئولیت تاخیر در انجام طرح بر عهده مجری می‌باشد. مدت زمان:
                  {{
                    proposal.gantData.length > 0
                      ? (Math.max(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        ) -
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )) /
                          3600 /
                          24 /
                          1000 +
                        " روز"
                      : ""
                  }}
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[1] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[1]"
                >
                  این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                  انجام:
                  {{
                    (
                      parseInt(
                        proposal.personnelCosts.length == 0
                          ? 0
                          : proposal.personnelCosts
                              .map(
                                (x) =>
                                  parseInt(x.perPersonCost) *
                                  parseInt(x.cooperationHour)
                              )
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      ) +
                      parseInt(
                        proposal.travelExpenses.length == 0
                          ? 0
                          : proposal.travelExpenses
                              .map((x) => x.cost)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      ) +
                      parseInt(
                        proposal.otherCosts.length == 0
                          ? 0
                          : proposal.otherCosts
                              .map((x) => x.totalPrice)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      ) +
                      parseInt(
                        proposal.purchases.length == 0
                          ? 0
                          : proposal.purchases
                              .map(
                                (x) => parseInt(x.perPrice) * parseInt(x.number)
                              )
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                      )
                    ).toLocaleString()
                  }}
                  تومان
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[2] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[2]"
                  >کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست فناوری
                  می‌باشد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[3] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[3]"
                  >توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود
                  دارد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[4] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[4]"
                  >نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه شده
                  است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[5] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[5]"
                >
                  بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده است. نام
                  بهره‌بردار:
                  {{ proposal.interactUniversityCenters }}
                </b-form-checkbox>
                <b-form-checkbox
                  :class="proposal.promiseArrays[6] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[6]"
                  >حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد
                  می‌شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[7] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[7]"
                  >تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت انجام
                  خواهد شد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[8] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[8]"
                  >کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان انجام طرح
                  به ستاد زیست فناوری ارسال و تحویل داده
                  می‌شود.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[9] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[9]"
                  >کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط مجری انجام و در
                  سایت بارگذاری می‌گردد.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[10] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[10]"
                  >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند و
                  به منزله ثبت درخواست متقاضی است.</b-form-checkbox
                >
                <b-form-checkbox
                  :class="proposal.promiseArrays[11] ? 'done' : 'required'"
                  v-model="proposal.promiseArrays[11]"
                  >کلیه موارد فوق مورد تایید اینجانب
                  {{
                    (proposal.researcherName ? proposal.researcherName : "-") +
                    " " +
                    proposal.researcherLastName
                  }}
                  به عنوان مجری طرح و همکاران می‌باشد.</b-form-checkbox
                >
              </b-form-group>
            </b-card>
          </b-tab>
          <b-tab :title="'مرور نهایی و ارسال طرح(' + lastStepProgress + '%)'">
            <b-card no-body class="mb-1">
              <b-card-header
                header-tag="header"
                class="p-1 border-0"
                role="tab"
              >
                <b-button block v-b-toggle.accordion-1 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    عنوان و حمایت‌های پیشین&nbsp;
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 0"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-1"
                visible
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>عنوان به زبان فارسی:</b> {{ proposal.faSubject }}
                      </li>
                      <li
                        :class="
                          proposal.initialIsSupported !== null
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b
                          >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                          استفاده کرده است؟</b
                        >
                        <b-form-radio-group
                          v-model="proposal.initialIsSupported"
                          disabled
                        >
                          <b-form-radio :value="true">بله</b-form-radio>
                          <b-form-radio :value="false">خیر</b-form-radio>
                        </b-form-radio-group>
                      </li>

                      <li
                        v-if="
                          proposal.initialIsSupported &&
                          proposal.initialSupportedType
                        "
                        :class="
                          proposal.initialSupportedType ? 'done' : 'required'
                        "
                      >
                        <b>حمایت ها:</b>
                        {{
                          options.filter(
                            (x) => x.value == proposal.initialSupportedType
                          )[0].text
                        }}
                      </li>
                      <li
                        v-if="
                          proposal.initialSupportedType == 'other' &&
                          proposal.initialIsSupported
                        "
                        :class="
                          proposal.initialOtherSupport ? 'done' : 'required'
                        "
                      >
                        <b>عنوان حمایت دریافتی:</b>
                        {{ proposal.initialOtherSupport }}
                      </li>
                      <li
                        v-if="proposal.initialIsSupported"
                        :class="
                          proposal.initialSupportDescription
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>توضیحات حمایت دریافتی:</b>
                        {{ proposal.initialSupportDescription }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-2 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات اصلی طرح&nbsp;({{ step1progress }}%)
                    <!-- NOTE (b-editThisSection-2) previus -->
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 1"
                  ></b-icon>
                </b-button>
              </b-card-header>

              <b-collapse
                id="accordion-2"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li :class="proposal.faSubject ? 'done' : 'required'">
                        <b>عنوان به زبان فارسی:</b> {{ proposal.faSubject }}
                      </li>
                      <li :class="proposal.enSubject ? 'done' : 'required'">
                        <b>عنوان به زبان انگلیسی:</b> {{ proposal.enSubject }}
                      </li>
                      <li
                        v-if="proposal.universityId"
                        :class="proposal.universityId ? 'done' : 'required'"
                      >
                        <b>دانشگاه محل اجرای طرح:</b>
                        {{
                          proposal.universityId
                            ? universities.filter(
                                (x) => x.id == proposal.universityId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.universityId == notUniversity"
                        :class="proposal.otherUniversity ? 'done' : 'required'"
                      >
                        <b>نام دانشگاه:</b> {{ proposal.otherUniversity }}
                      </li>
                      <li
                        v-if="proposal.mehvarId != notMehvar"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور طرح:</b>
                        {{
                          proposal.mehvarId
                            ? mehvars.filter(
                                (x) => x.id == proposal.mehvarId
                              )[0].text
                            : ""
                        }}
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.mehvarId ? 'done' : 'required'"
                      >
                        <b>محور طرح:</b> سایر محورها
                      </li>
                      <li
                        v-if="proposal.mehvarId == notMehvar"
                        :class="proposal.otherMehvars ? 'done' : 'required'"
                      >
                        <b>نام محور:</b> {{ proposal.otherMehvars }}
                      </li>
                      <li
                        :class="
                          proposal.typeStudy ||
                          proposal.typeSystemicDevelopmental ||
                          proposal.typePractical
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>ماهیت طرح:</b>
                        <b-form-group
                          disabled
                          :class="
                            proposal.typeStudy ||
                            proposal.typeSystemicDevelopmental ||
                            proposal.typePractical
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b-form-checkbox v-model="proposal.typeStudy"
                            >مطالعاتی</b-form-checkbox
                          >
                          <b-form-checkbox
                            v-model="proposal.typeSystemicDevelopmental"
                            >سیستمی و توسعه‌ای</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.typePractical"
                            >کاربردی</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                      <li
                        :class="
                          proposal.zoneMedicine ||
                          proposal.zoneAgriculture ||
                          proposal.zoneEnvironment ||
                          proposal.zoneIndustrial ||
                          proposal.zoneBioComputing ||
                          proposal.zoneOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>حوزه طرح:</b>
                        <b-form-group disabled>
                          <b-form-checkbox v-model="proposal.zoneMedicine"
                            >پزشکی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneAgriculture"
                            >کشاورزی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneEnvironment"
                            >محیط زیست</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneIndustrial"
                            >صنعتی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneBioComputing"
                            >رایانش زیستی</b-form-checkbox
                          >
                          <b-form-checkbox v-model="proposal.zoneOther"
                            >سایر</b-form-checkbox
                          >
                        </b-form-group>
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-3 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات مجری طرح&nbsp;({{ step2progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 2"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-3"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li
                        :class="proposal.researcherName ? 'done' : 'required'"
                      >
                        <b>نام:</b> {{ proposal.researcherName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherLastName ? 'done' : 'required'
                        "
                      >
                        <b>نام خانوادگی:</b> {{ proposal.researcherLastName }}
                      </li>
                      <li
                        :class="
                          proposal.researcherNatCode ? 'done' : 'required'
                        "
                      >
                        <b>کدملی:</b> {{ proposal.researcherNatCode }}
                      </li>
                      <li
                        :class="proposal.researcherMobile ? 'done' : 'required'"
                      >
                        <b>تلفن همراه:</b> {{ proposal.researcherMobile }}
                      </li>
                      <li :class="proposal.researcherFax ? 'done' : 'required'">
                        <b>دورنگار:</b> {{ proposal.researcherFax }}
                      </li>
                      <li
                        :class="proposal.researcherEmail ? 'done' : 'required'"
                      >
                        <b>پست الکترونیکی:</b> {{ proposal.researcherEmail }}
                      </li>
                      <li
                        :class="
                          proposal.researcherStateId ? 'done' : 'required'
                        "
                      >
                        <b>استان:</b>
                        {{
                          proposal.researcherState
                            ? proposal.researcherState
                            : "-"
                        }}
                      </li>
                      <li
                        :class="proposal.researcherCityId ? 'done' : 'required'"
                      >
                        <b>شهر:</b>
                        {{
                          proposal.researcherCity
                            ? proposal.researcherCity
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="proposal.researcherUniversityId"
                        :class="
                          proposal.researcherUniversityId ? 'done' : 'required'
                        "
                      >
                        <b>دانشگاه محل تحصیل:</b>
                        {{
                          proposal.researcherUniversityId
                            ? universities.filter(
                                (x) => x.id == proposal.researcherUniversityId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="proposal.researcherUniversityId == notUniversity"
                        :class="
                          proposal.researcherUniversityOther
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>نام دانشگاه:</b>
                        {{ proposal.researcherUniversityOther }}
                      </li>
                      <li
                        v-if="proposal.researcherUniversityJobId"
                        class="'done'"
                      >
                        <b>دانشگاه محل اشتغال به عنوان عضوهئیت علمی:</b>
                        {{
                          proposal.researcherUniversityJobId
                            ? universities.filter(
                                (x) =>
                                  x.id == proposal.researcherUniversityJobId
                              )[0].text
                            : "-"
                        }}
                      </li>
                      <li
                        v-if="
                          proposal.researcherUniversityJobId == notUniversity
                        "
                      >
                        <b>نام دانشگاه:</b>
                        {{ proposal.researcherUniversityJobOther }}
                      </li>
                      <li
                        :class="
                          proposal.researcherLastDegree ? 'done' : 'required'
                        "
                      >
                        <b>آخرین مدرک تحصیلی:</b>
                        {{ proposal.researcherLastDegree }}
                      </li>
                      <li
                        :class="
                          proposal.researcherResearch ? 'done' : 'required'
                        "
                      >
                        <b
                          >اهم فعالیت‌های تحقیقاتی پایان یافته و یا در حال اجراء
                          و تألیفات در ارتباط مستقیم با موضوع طرح:</b
                        >
                        {{ proposal.researcherResearch }}
                      </li>
                      <li
                        :class="
                          proposal.researcherIndustry ? 'done' : 'required'
                        "
                      >
                        <b
                          >اهم فعالیت‌های صنعتی پایان یافته و یا در حال اجرا در
                          ارتباط مستقیم با موضوع طرح:</b
                        >
                        {{ proposal.researcherIndustry }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-4 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    اطلاعات همکاران طرح&nbsp;({{ step3progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 3"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-4"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    تعداد همکاران طرح: {{ proposal.colleagues.length }}
                    <b-card
                      class="mt-3 border-0 shadow-sm"
                      v-for="(colleague, index) in proposal.colleagues"
                      :key="index"
                    >
                      <template v-slot:header>
                        <strong>همکار شماره {{ index + 1 }}</strong>
                      </template>
                      <ul>
                        <li :class="colleague.name ? 'done' : 'required'">
                          <b>نام:</b> {{ colleague.name }}
                        </li>
                        <li :class="colleague.lastName ? 'done' : 'required'">
                          <b>نام خانوادگی:</b> {{ colleague.lastName }}
                        </li>
                        <li :class="colleague.natCode ? 'done' : 'required'">
                          <b>کدملی:</b> {{ colleague.natCode }}
                        </li>
                        <li :class="colleague.mobile ? 'done' : 'required'">
                          <b>تلفن همراه:</b> {{ colleague.mobile }}
                        </li>
                        <li :class="colleague.email ? 'done' : 'required'">
                          <b>پست الکترونیکی:</b> {{ colleague.email }}
                        </li>
                        <li :class="colleague.position ? 'done' : 'required'">
                          <b>سمت:</b> {{ colleague.position }}
                        </li>
                        <li
                          v-if="colleague.universityId"
                          :class="colleague.universityId ? 'done' : 'required'"
                        >
                          <b>دانشگاه محل تحصیل:</b>
                          {{
                            colleague.universityId
                              ? universities.filter(
                                  (x) => x.id == colleague.universityId
                                )[0].text
                              : "-"
                          }}
                        </li>
                        <li
                          v-if="colleague.universityId == notUniversity"
                          :class="
                            colleague.universityOther ? 'done' : 'required'
                          "
                        >
                          <b>نام دانشگاه:</b> {{ colleague.universityOther }}
                        </li>
                        <li v-if="colleague.universityJobId">
                          <b>دانشگاه محل اشتغال به عنوان عضوهئیت علمی:</b>
                          {{
                            colleague.universityJobId
                              ? universities.filter(
                                  (x) => x.id == colleague.universityJobId
                                )[0].text
                              : "-"
                          }}
                        </li>
                        <li v-if="colleague.universityJobId == notUniversity">
                          <b>نام دانشگاه:</b> {{ colleague.universityJobOther }}
                        </li>
                        <li :class="colleague.lastDegree ? 'done' : 'required'">
                          <b>آخرین مدرک تحصیلی:</b> {{ colleague.lastDegree }}
                        </li>
                        <li :class="colleague.resumeFile ? 'done' : 'required'">
                          <b>رزومه همکار:</b>
                          <a
                            v-if="colleague.resumeFile"
                            :href="colleague.resumeFile"
                            target="blank"
                            >دانلود</a
                          >
                          <span v-else>--</span>
                        </li>
                      </ul>
                    </b-card>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-5 variant="info">
                  <h5 class="mb-0 text-white" style="display: inline-block">
                    مشخصات طرح&nbsp;({{ step4progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 4"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-5"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <ul>
                      <li
                        class="mb-4"
                        :class="proposal.abstract ? 'done' : 'required'"
                      >
                        <b>چکیده طرح:</b> {{ proposal.abstract }}
                      </li>
                      <li
                        class="mb-4"
                        :class="proposal.requestNecessity ? 'done' : 'required'"
                      >
                        <b
                          >ضرورت اجرای طرح (در جهت دستیابی به اهداف ستاد و یا
                          راهبردها و اقدامات سند توسعه زیست فناوری):</b
                        >
                        {{ proposal.requestNecessity }}
                      </li>
                      <li
                        class="mb-4"
                        :class="proposal.majorGoals ? 'done' : 'required'"
                      >
                        <b>اهداف کلان طرح:</b> {{ proposal.majorGoals }}
                      </li>
                      <li
                        class="mb-4"
                        :class="proposal.minorGoals ? 'done' : 'required'"
                      >
                        <b>اهداف خرد طرح:</b> {{ proposal.minorGoals }}
                      </li>
                      <li
                        class="mb-4"
                        :class="
                          proposal.benefitsToCountry ? 'done' : 'required'
                        "
                      >
                        <b>مزایای دیگر برای کشور:</b>
                        {{ proposal.benefitsToCountry }}
                      </li>
                      <li
                        class="mb-4"
                        :class="proposal.methodology ? 'done' : 'required'"
                      >
                        <b>روش شناسی (متدولوژی) و مراحل انجام طرح:</b>
                        {{ proposal.methodology }}
                      </li>
                      <li
                        class="mb-4"
                        :class="
                          proposal.requestProducts.length > 0
                            ? 'done'
                            : 'required'
                        "
                        v-if="proposal.requestProducts.length > 0"
                      >
                        <b>
                          دستاوردهای عینی و خروجی‌های ملموس(محصول/ محصولات و یا
                          خدمات) حاصل از اجرای طرح:</b
                        >
                        <!-- NOTE (t-achievmentItems-2) previous -->
                        <b-table
                          responsive
                          small
                          show-empty
                          head-variant="dark"
                          :items="proposal.requestProducts"
                          :fields="achievmentFields"
                          empty-text="رکوردی برای نمایش وجود ندارد"
                          class="table table-secondary my-3"
                        >
                          <template v-slot:head()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.label }}
                            </div>
                          </template>
                          <template v-slot:cell()="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.value }}
                            </div>
                          </template>
                          <template v-slot:cell(index)="data">
                            <div
                              style="text-align: center; vertical-align: middle"
                            >
                              {{ data.index + 1 }}
                            </div>
                          </template>
                        </b-table>
                      </li>
                      <li
                        class="mb-4"
                        :class="
                          proposal.executionHistorySimilar ? 'done' : 'required'
                        "
                      >
                        <b
                          >سابقه اجرائی یا طرح‌های مشابه در ایران یا خارج از
                          كشور (با ذكر ماخذ):</b
                        >
                        {{ proposal.executionHistorySimilar }}
                      </li>
                      <li
                        class="mb-4"
                        :class="
                          proposal.internationalPartners ? 'done' : 'required'
                        "
                      >
                        <b>شركای بین‌المللی در اجرای طرح :</b>
                        {{ proposal.internationalPartners }}
                      </li>
                      <li
                        class="mb-4"
                        :class="proposal.references ? 'done' : 'required'"
                      >
                        <b>منابع و ماخذ:</b> {{ proposal.references }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-6 variant="warning">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات تجاری‌سازی&nbsp;({{ step5progress }}%)
                  </h5>

                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 5"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-6"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="p-3 shadow">
                    <h4 class="mb-6">
                      نوع تجاری‌سازی:
                      {{
                        proposal.commercializingType == "company"
                          ? "شرکت دانش بنیان"
                          : proposal.commercializingType == "accelerator"
                          ? "شتاب‌دهنده"
                          : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                      }}
                    </h4>
                    <div v-if="proposal.commercializingType == 'company'">
                      <ul>
                        <li
                          v-if="proposal.companyId != notCompany"
                          :class="proposal.companyId ? 'done' : 'required'"
                        >
                          <b>نام شرکت دانش بنیان:</b>
                          {{
                            proposal.companyId
                              ? companies.filter(
                                  (x) => x.id == proposal.companyId
                                )[0].text
                              : "-"
                          }}
                        </li>
                        <li
                          v-if="proposal.companyId == notCompany"
                          :class="
                            proposal.otherCompanyName ? 'done' : 'required'
                          "
                        >
                          <b>نام شرکت:</b> {{ proposal.otherCompanyName }}
                        </li>
                        <li
                          v-if="proposal.companyId != notCompany"
                          :class="proposal.companyId ? 'done' : 'required'"
                        >
                          <b>شماره ثبت شرکت:</b>
                          {{
                            proposal.companyRegistrationNumber
                              ? proposal.companyRegistrationNumber
                              : "-"
                          }}
                        </li>
                        <li
                          v-else
                          :class="
                            proposal.otherCompanyRegistrationNumber
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b>شماره ثبت شرکت:</b>
                          {{ proposal.otherCompanyRegistrationNumber }}
                        </li>
                        <li
                          v-if="proposal.companyId != notCompany"
                          :class="proposal.companyId ? 'done' : 'required'"
                        >
                          <b>شناسه ملی شرکت:</b>
                          {{
                            proposal.companyNationalId
                              ? proposal.companyNationalId
                              : "-"
                          }}
                        </li>
                        <li
                          v-else
                          :class="
                            proposal.otherCompanyNationalId
                              ? 'done'
                              : 'required'
                          "
                        >
                          <b>شناسه ملی شرکت:</b>
                          {{ proposal.otherCompanyNationalId }}
                        </li>
                        <li
                          :class="
                            proposal.companyProducts ? 'done' : 'required'
                          "
                        >
                          <b>معرفی فناوری یا محصولات شرکت:</b>
                          {{ proposal.companyProducts }}
                        </li>
                        <li
                          :class="
                            proposal.companyContactInfo ? 'done' : 'required'
                          "
                        >
                          <b>آدرس پستی / شماره تماس/ پست الکترونیک شرکت:</b>
                          {{ proposal.companyContactInfo }}
                        </li>
                      </ul>
                    </div>
                    <div
                      v-if="proposal.commercializingType == 'accelerator'"
                      :class="proposal.acceleratorId ? 'done' : 'required'"
                    >
                      <b> نام شتاب‌دهنده:</b>
                      {{
                        proposal.acceleratorId
                          ? accelerators.filter(
                              (x) => x.id == proposal.acceleratorId
                            )[0].text
                          : ""
                      }}
                    </div>
                    <ul v-if="proposal.commercializingType == 'none'">
                      <li
                        class="mb-4 d-flex flex-row"
                        :class="
                          proposal.commercializingObligation1
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-checkbox
                          v-model="proposal.commercializingObligation1"
                          disabled
                          class="me-4"
                        ></b-form-checkbox>
                        تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست
                        توسط یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه
                        زیست فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد
                        داشت.
                      </li>
                      <li
                        class="d-flex flex-row"
                        :class="
                          proposal.commercializingObligation2
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b-form-checkbox
                          v-model="proposal.commercializingObligation2"
                          disabled
                          class="me-4"
                        ></b-form-checkbox>
                        تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و
                        علمی این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های
                        مجاز قرار خواهد گرفت تا بتوانند با بررسی اطلاعات،
                        درخواست بنده را بررسی و تایید کنند.
                      </li>
                    </ul>
                    <h5 class="text-primary mt-4">
                      ملاحظات مربوط به همکاری طرفین، بازار و عایدی طرح
                    </h5>
                    <ul>
                      <li
                        :class="
                          proposal.interactUniversityCenters
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b
                          >نحوه تعامل با دانشگاه یا مراکز و ملاحظات مربوط به حق
                          مالکیت:</b
                        >
                        {{ proposal.interactUniversityCenters }}
                      </li>
                      <br />
                      <li :class="proposal.targetMarket ? 'done' : 'required'">
                        <b>معرفی بازار هدف:</b> {{ proposal.targetMarket }}
                      </li>
                      <br />

                      <li
                        :class="
                          proposal.productSalesForecast ? 'done' : 'required'
                        "
                      >
                        <b>پیش بینی میزان فروش محصول در سه سال اول:</b>
                        {{ proposal.productSalesForecast }}
                      </li>
                      <br />

                      <li :class="proposal.employment ? 'done' : 'required'">
                        <b>میزان اشتغال زایی طرح:</b>
                        {{ proposal.employment }}
                      </li>
                      <br />

                      <li
                        :class="
                          proposal.durationCooperation ? 'done' : 'required'
                        "
                      >
                        <b>برآورد مدت زمان همکاری:</b>
                        {{ proposal.durationCooperation }}
                      </li>
                      <br />

                      <li
                        :class="
                          proposal.estimationProductionProjectRevenue
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>برآورد میزان تولید و عایدی طرح:</b>
                        {{ proposal.estimationProductionProjectRevenue }}
                      </li>
                      <br />

                      <li
                        :class="
                          proposal.competitiveProductsLevelCompetitiveness
                            ? 'done'
                            : 'required'
                        "
                      >
                        <b>محصولات رقیب و میزان رقابت پذیری(مقایسه قیمت):</b>
                        {{ proposal.competitiveProductsLevelCompetitiveness }}
                      </li>
                      <br />

                      <li
                        :class="
                          proposal.productAdvantages ? 'done' : 'required'
                        "
                      >
                        <b>مزیت محصول نسبت به موارد مشابه و موجود:</b>
                        {{ proposal.productAdvantages }}
                      </li>
                    </ul>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-7 variant="light">
                  <h5 class="mb-0" style="display: inline-block">
                    زمانبندی طرح&nbsp;({{ step6progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 6"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-7"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    زمان شروع:
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.min(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.startDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                    <br />
                    زمان پایان:
                    {{
                      proposal.gantData.length > 0
                        ? moment(
                            new Date(
                              Math.max(
                                ...proposal.gantData.map((x) =>
                                  new Date(
                                    moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                      "YYYY-MM-DD"
                                    )
                                  ).getTime()
                                )
                              )
                            )
                          ).format("jYYYY/jMM/jDD")
                        : ""
                    }}
                    <br />
                    مدت زمان:
                    {{
                      proposal.gantData.length > 0
                        ? (Math.max(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          ) -
                            Math.min(
                              ...proposal.gantData.map((x) =>
                                new Date(
                                  moment(x.startDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            )) /
                            3600 /
                            24 /
                            1000 +
                          " روز"
                        : ""
                    }}
                    <br />
                    <div>
                      <sarmadGantt
                        v-if="show"
                        :items="proposal.gantData"
                        :fields="serviceFields"
                      />
                    </div>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-8 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    هزینه‌ها&nbsp;({{ step7progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 7"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-8"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <div v-if="proposal.personnelCosts.length > 0">
                      <hr />
                      <h5 class="mt-5 mb-3 text-primary">
                        هزینه‌های پرسنلی اعم از مجری و همكاران
                      </h5>

                      <!-- NOTE (t-personnelCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.personnelCosts"
                        :fields="PersonnelCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary mb-4"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                        <template v-slot:cell(humanResourceCost)="data">
                          <div>
                            {{
                              (
                                parseInt(data.item.perPersonCost) *
                                parseInt(data.item.cooperationHour)
                              ).toLocaleString()
                            }}
                          </div>
                        </template>
                      </b-table>
                      <p>
                        جمع کل هزینه های پرسنلی:
                        {{
                          proposal.personnelCosts.length == 0
                            ? 0
                            : proposal.personnelCosts
                                .map(
                                  (x) =>
                                    parseInt(x.perPersonCost) *
                                    parseInt(x.cooperationHour)
                                )
                                .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                                .toLocaleString()
                        }}
                        تومان
                      </p>
                    </div>

                    <div v-if="proposal.travelExpenses.length > 0">
                      <h5 class="mt-5 mb-3 text-primary">
                        هزینه مسافرت‌های ضروری (اعم از هزینه بلیط، اسكان، غذا،
                        حمل و نقل، حق مأموریت و ...):
                      </h5>

                      <!-- NOTE (t-tripCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.travelExpenses"
                        :fields="tripCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary mb-4"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                      جمع کل مسافرتهای ضروری:
                      {{
                        proposal.travelExpenses.length == 0
                          ? 0
                          : proposal.travelExpenses
                              .map((x) => x.cost)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                              .toLocaleString()
                      }}
                      تومان
                    </div>
                    <div v-if="proposal.purchases.length > 0">
                      <h5 class="mt-5 mb-3 text-primary">
                        هزینه دستگاه‌ها، وسایل و مواد مورد نیازكه باید از محل
                        اعتبار طرح خریداری شوند:
                      </h5>

                      <!-- NOTE (t-deviceCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.purchases"
                        :fields="deviceCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                        <template v-slot:cell(totalPrice)="data">
                          <div>
                            {{
                              (
                                parseInt(data.item.number) *
                                parseInt(data.item.perPrice)
                              ).toLocaleString()
                            }}
                          </div>
                        </template>
                      </b-table>
                      جمع کل هزینه دستگاه‌ها:
                      {{
                        proposal.purchases.length == 0
                          ? 0
                          : proposal.purchases
                              .map(
                                (x) => parseInt(x.perPrice) * parseInt(x.number)
                              )
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                              .toLocaleString()
                      }}
                      تومان
                      <hr />
                    </div>

                    <div
                      v-if="proposal.participationOrganizationBudget.length > 0"
                    >
                      <h5 class="mt-5 mb-3 text-primary">
                        میزان مشارکت سایر موسسات:
                      </h5>

                      <!-- NOTE (t-orgCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.participationOrganizationBudget"
                        :fields="OrgCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                      جمع کل مشارکت موسسات:
                      {{
                        proposal.participationOrganizationBudget.length == 0
                          ? 0
                          : proposal.participationOrganizationBudget
                              .map((x) => x.totalPrice)
                              .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                              .toLocaleString()
                      }}
                      تومان
                    </div>
                    <div
                      v-show="
                        proposal.otherCosts
                          .map((x) => x.totalPrice)
                          .reduce((a, b) => parseInt(a) + parseInt(b), 0) > 0
                      "
                    >
                      <h5 class="mt-5 mb-3 text-primary">هزینه‌های دیگر:</h5>

                      <!-- NOTE (t-otherCost2) previous -->
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="dark"
                        :items="proposal.otherCosts"
                        :fields="otherCostField"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>
                      </b-table>
                      <p>
                        جمع کل سایر هزینه‌ها:
                        {{
                          proposal.otherCosts.length == 0
                            ? 0
                            : proposal.otherCosts
                                .map((x) => x.totalPrice)
                                .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                                .toLocaleString()
                        }}
                        تومان
                      </p>
                    </div>
                    <h3>
                      جمع کل هزینه‌ها:
                      {{
                        (tPrice = (
                          (proposal.personnelCosts.length == 0
                            ? 0
                            : proposal.personnelCosts
                                .map(
                                  (x) =>
                                    parseInt(x.perPersonCost) *
                                    parseInt(x.cooperationHour)
                                )
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.travelExpenses.length == 0
                            ? 0
                            : proposal.travelExpenses
                                .map((x) => x.cost)
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.purchases.length == 0
                            ? 0
                            : proposal.purchases
                                .map(
                                  (x) =>
                                    parseInt(x.perPrice) * parseInt(x.number)
                                )
                                .reduce(
                                  (a, b) => parseInt(a) + parseInt(b),
                                  0
                                )) +
                          (proposal.otherCosts.length == 0
                            ? 0
                            : proposal.otherCosts
                                .map((x) => x.totalPrice)
                                .reduce((a, b) => parseInt(a) + parseInt(b), 0))
                        ).toLocaleString())
                      }}
                      تومان
                    </h3>
                    <hr />
                    <h3>
                      میزان اعتبار مورد نیاز از ستاد زیست فناوری:
                      {{ computedTotalCost.toLocaleString() }}
                      تومان
                    </h3>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-9 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    اطلاعات داوران پیشنهادی&nbsp;({{ step8progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 8"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-9"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    تعداد داوران طرح: {{ proposal.reviewers.length }}
                    <b-card
                      class="mt-3 border-0 shadow-sm"
                      v-for="(reviewer, index) in proposal.reviewers"
                      :key="index"
                    >
                      <template v-slot:header>
                        <strong>داور شماره {{ index + 1 }}</strong>
                      </template>
                      <ul>
                        <li :class="reviewer.name ? 'done' : 'required'">
                          <b>نام:</b> {{ reviewer.name }}
                        </li>
                        <li :class="reviewer.lastName ? 'done' : 'required'">
                          <b>نام خانوادگی:</b> {{ reviewer.lastName }}
                        </li>
                        <li :class="reviewer.expertise ? 'done' : 'required'">
                          <b>حوزه کاری:</b> {{ reviewer.expertise }}
                        </li>
                        <li :class="reviewer.field ? 'done' : 'required'">
                          <b>رشته تحصیلی:</b> {{ reviewer.field }}
                        </li>
                        <li :class="reviewer.lastDegree ? 'done' : 'required'">
                          <b>آخرین مدرک تحصیلی:</b> {{ reviewer.lastDegree }}
                        </li>
                        <li :class="reviewer.lastDegree ? 'done' : 'required'">
                          <b>رتبه علمی:</b> {{ reviewer.academicRank }}
                        </li>
                        <li :class="reviewer.email ? 'done' : 'required'">
                          <b>پست الکترونیکی:</b> {{ reviewer.email }}
                        </li>
                        <li :class="reviewer.mobile ? 'done' : 'required'">
                          <b>شماره تماس:</b> {{ reviewer.mobile }}
                        </li>
                      </ul>
                    </b-card>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-10 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    فایل‌های تکمیلی&nbsp;({{ step9progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 9"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-10"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-table
                      responsive
                      show-empty
                      head-variant="dark"
                      :fields="fileFields"
                      :items="files.filter((x) => x && x.url != '')"
                      empty-text="فایلی وجود ندارد"
                      striped
                      :busy="fileBusy"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>

                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(url)="data">
                        <div style="text-align: center; vertical-align: middle">
                          <!-- NOTE (<a>) to download the user uploaded file by opening a new page -->
                          <a
                            v-if="data.value"
                            class="btn btn-success white--text"
                            :href="data.value"
                            target="_blank"
                            >دریافت فایل</a
                          >
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <strong>در حال بارگذاری...</strong>
                        <br />
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </b-table>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.accordion-11 variant="dark">
                  <h5 class="mb-0" style="display: inline-block">
                    تعهدات&nbsp;({{ step10progress }}%)
                  </h5>
                  <b-icon
                    icon="pencil-square"
                    font-scale="2"
                    aria-hidden="true"
                    style="float: left"
                    @click="tabIndex = 10"
                  ></b-icon>
                </b-button>
              </b-card-header>
              <b-collapse
                id="accordion-11"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <b-card-text class="shadow p-3">
                    <b-form-group disabled>
                      <b-form-checkbox v-model="proposal.promiseArrays[0]">
                        <b
                          :class="
                            proposal.promiseArrays[0] ? 'done' : 'required'
                          "
                          >این طرح در مدت زمان اعلام شده در پروپوزال انجام
                          می‌گردد و مسئولیت تاخیر در انجام طرح بر عهده مجری
                          می‌باشد. مدت زمان:
                          {{
                            proposal.gantData.length > 0
                              ? (Math.max(
                                  ...proposal.gantData.map((x) =>
                                    new Date(
                                      moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                        "YYYY-MM-DD"
                                      )
                                    ).getTime()
                                  )
                                ) -
                                  Math.min(
                                    ...proposal.gantData.map((x) =>
                                      new Date(
                                        moment(
                                          x.startDate,
                                          "jYYYY/jMM/jDD"
                                        ).format("YYYY-MM-DD")
                                      ).getTime()
                                    )
                                  )) /
                                  3600 /
                                  24 /
                                  1000 +
                                " روز"
                              : ""
                          }}</b
                        >
                      </b-form-checkbox>
                      <b-form-checkbox v-model="proposal.promiseArrays[1]">
                        <b
                          :class="
                            proposal.promiseArrays[1] ? 'done' : 'required'
                          "
                        >
                          این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد.
                          هزینه انجام:
                          {{
                            (
                              parseInt(
                                proposal.personnelCosts.length == 0
                                  ? 0
                                  : proposal.personnelCosts
                                      .map(
                                        (x) =>
                                          parseInt(x.perPersonCost) *
                                          parseInt(x.cooperationHour)
                                      )
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      )
                              ) +
                              parseInt(
                                proposal.travelExpenses.length == 0
                                  ? 0
                                  : proposal.travelExpenses
                                      .map((x) => x.cost)
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      )
                              ) +
                              parseInt(
                                proposal.otherCosts.length == 0
                                  ? 0
                                  : proposal.otherCosts
                                      .map((x) => x.totalPrice)
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      )
                              ) +
                              parseInt(
                                proposal.purchases.length == 0
                                  ? 0
                                  : proposal.purchases
                                      .map(
                                        (x) =>
                                          parseInt(x.perPrice) *
                                          parseInt(x.number)
                                      )
                                      .reduce(
                                        (a, b) => parseInt(a) + parseInt(b),
                                        0
                                      )
                              )
                            ).toLocaleString()
                          }}
                          تومان
                        </b>
                      </b-form-checkbox>
                      <b-form-checkbox v-model="proposal.promiseArrays[2]"
                        ><b
                          :class="
                            proposal.promiseArrays[2] ? 'done' : 'required'
                          "
                        >
                          کلیه حقوق مادی و معنوی این طرح متعلق به ستاد زیست
                          فناوری می‌باشد.
                        </b></b-form-checkbox
                      >
                      <b-form-checkbox v-model="proposal.promiseArrays[3]"
                        ><b
                          :class="
                            proposal.promiseArrays[3] ? 'done' : 'required'
                          "
                          >توافق بین دانشگاه و صنعت در خصوص دستاوردهای طرح وجود
                          دارد.</b
                        ></b-form-checkbox
                      >
                      <b-form-checkbox v-model="proposal.promiseArrays[4]"
                        ><b
                          :class="
                            proposal.promiseArrays[4] ? 'done' : 'required'
                          "
                          >نحوه و مسیر تجاری سازی طرح مشخص است و مستندات ارائه
                          شده است.</b
                        ></b-form-checkbox
                      >
                      <b-form-checkbox v-model="proposal.promiseArrays[5]">
                        <b
                          :class="
                            proposal.promiseArrays[5] ? 'done' : 'required'
                          "
                          >بهره‌بردار نهایی طرح مشخص است و مستندات ارائه شده
                          است. نام بهره‌بردار:
                          {{
                            (proposal.researcherName
                              ? proposal.researcherName
                              : "-") +
                            "" +
                            (proposal.researcherLastName
                              ? proposal.researcherLastName
                              : "")
                          }}</b
                        >
                      </b-form-checkbox>
                      <b-form-checkbox v-model="proposal.promiseArrays[6]">
                        <b
                          :class="
                            proposal.promiseArrays[6] ? 'done' : 'required'
                          "
                          >حداقل 1 مقاله ISI معتبر به عنوان خروجی طرح تعهد
                          می‌شود.</b
                        >
                      </b-form-checkbox>
                      <b-form-checkbox v-model="proposal.promiseArrays[7]">
                        <b
                          :class="
                            proposal.promiseArrays[7] ? 'done' : 'required'
                          "
                          >تمامی گزارش‌ها پیشرفت در موعد مقرر مطابق با گانت چارت
                          انجام خواهد شد.</b
                        >
                      </b-form-checkbox>
                      <b-form-checkbox v-model="proposal.promiseArrays[8]"
                        ><b
                          :class="
                            proposal.promiseArrays[8] ? 'done' : 'required'
                          "
                        >
                          کلیه گزارش‌ها و خروجی‌ها و دستاوردهای طرح در پایان
                          انجام طرح به ستاد زیست فناوری ارسال و تحویل داده
                          می‌شود.
                        </b></b-form-checkbox
                      >
                      <b-form-checkbox v-model="proposal.promiseArrays[9]"
                        ><b
                          :class="
                            proposal.promiseArrays[9] ? 'done' : 'required'
                          "
                          >کلیه اصلاحات در مورد مقرر و طی 2 هفته توسط مجری انجام
                          و در سایت بارگذاری می‌گردد.</b
                        ></b-form-checkbox
                      >
                      <b-form-checkbox v-model="proposal.promiseArrays[10]"
                        ><b
                          :class="
                            proposal.promiseArrays[10] ? 'done' : 'required'
                          "
                        >
                          ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد
                          نمی‌کند و به منزله ثبت درخواست متقاضی است.
                        </b></b-form-checkbox
                      >
                      <b-form-checkbox v-model="proposal.promiseArrays[11]"
                        ><b
                          :class="
                            proposal.promiseArrays[11] ? 'done' : 'required'
                          "
                        >
                          کلیه موارد فوق مورد تایید اینجانب
                          {{
                            (proposal.researcherName
                              ? proposal.researcherName
                              : "-") +
                            " " +
                            (proposal.researcherLastName
                              ? proposal.researcherLastName
                              : "")
                          }}
                          به عنوان مجری طرح و همکاران می‌باشد.
                        </b></b-form-checkbox
                      >
                    </b-form-group>
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>

            <!-- NOTE (b-submitProposal) to submit proposal -->

            <b-button
              class="m-2"
              variant="success"
              :disabled="lastStepProgress != 100"
              @click="submitProposal()"
              >ارسال طرح</b-button
            >
            <p v-if="lastStepProgress != 100" class="required">
              به منظور ارسال طرح باید تمام مراحل را به صورت کامل (100%) پشت سر
              گذاشته باشید.
            </p>
          </b-tab>
        </b-tabs>
        <div class="d-flex justify-content-center mt-3">
          <!-- NOTE (b-previousPage-2) previous -->
          <b-button
            v-if="tabIndex != 0"
            class="mx-1"
            variant="light"
            @click="changePage('back')"
            >مرحله قبل</b-button
          >

          <!-- NOTE (b-saveDraft-2) previous -->
          <b-button
            :disabled="isSaving"
            class="mx-1"
            variant="success"
            @click="saveDraft()"
            >ثبت پیشنویس</b-button
          >

          <!-- NOTE (b-nextPage-2) previous -->
          <b-button
            v-if="tabIndex != 11"
            class="mx-1"
            variant="primary"
            @click="changePage('next')"
            >مرحله بعد</b-button
          >
        </div>
      </b-card>
      <b-modal
        id="modal"
        ref="delReviewer"
        header-bg-variant="primary"
        header-text-variant="white"
        class="text-center"
        size="md"
      >
        <template v-slot:modal-header>
          <h4>حذف داور طرح</h4>
        </template>
        <template v-slot:modal-footer>
          <b-row>
            <b-col cols="1"></b-col>
            <b-col cols="10">
              <!-- NOTE (b-doDeleteReviewer) to confirm the reviewer removal -->
              <b-button variant="danger" size="lg" @click="doDeleteReviewer()"
                >حذف کن</b-button
              >

              <!-- NOTE (b-doDeleteReviewer) to cancel the reviewer removal -->
              <b-button
                variant="warning"
                size="lg"
                class="ml-2"
                @click="hideModal('delReviewer')"
                >لغو</b-button
              >
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>
        </template>
        ایا از حذف این داور مطمئن هستید؟
        <br />
        <br />این کار غیر قابل برگشت خواهد بود!
      </b-modal>
      <b-modal
        id="modal"
        ref="delColleague"
        header-bg-variant="primary"
        header-text-variant="white"
        class="text-center"
        size="md"
      >
        <template v-slot:modal-header>
          <h4>حذف همکار طرح</h4>
        </template>
        <template v-slot:modal-footer>
          <b-row>
            <b-col cols="1"></b-col>
            <b-col cols="10">
              <!-- NOTE (b-doDeleteColleague) to confirm the Colleague removal -->
              <b-button variant="danger" size="lg" @click="doDeleteColleague()"
                >حذف کن</b-button
              >

              <!-- NOTE (b-doDeleteColleague) to cancel the Colleague removal -->
              <b-button
                variant="warning"
                size="lg"
                class="ml-2"
                @click="hideModal('delColleague')"
                >لغو</b-button
              >
            </b-col>
            <b-col cols="1"></b-col>
          </b-row>
        </template>
        ایا از حذف این همکار مطمئن هستید؟
        <br />
        <br />این کار غیر قابل برگشت خواهد بود!
      </b-modal>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("../../components/sarmadGantt");
import { Compact } from "vue-color"; // REVIEW
import ColourPicker from "vue-colour-picker"; // REVIEW
import mixin from "../../mixins/utilities";

export default {
  mixins: [mixin],
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
    sarmadGantt: sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    compact: Compact,
    ColourPicker,
  },
  data() {
    return {
      pageLoaded: false,
      notLoaded: false,
      reactivity: false,
      descriptionTemplates: [
        { title: "", description: "" },
        { title: "", description: "نامه شورای پژوهش یا فناوری دانشگاه" },
        { title: "", description: "نامه صنعت یا شرکت" },
        { title: "", description: "توافقنامه دانشگاه با صنعت" },
        { title: "", description: "" },
        { title: "", description: "" },
        { title: "", description: "" },
      ],
      enName: "",
      error: "",
      research: false,
      industry: false,
      agreement: false,
      account: false,
      myshow: false,
      selectedMehvar: 0,
      infoo: "",
      moment: moment,
      show: false,
      fileBusy: true,
      config: {
        locale: {
          name: "en",
        },
        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],

      universities: [],
      max: 100,
      tPrice: "",
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      fileTitles: [
        "نامه شورای پژوهش یا فناوری دانشگاه",
        "توافقنامه دانشگاه با صنعت",
        "سایر مدارک (1)",
        "سایر مدارک (2)",
        "سایر مدارک (3)",
      ],
      source: "",
      deviceCostItem: [],
      otherCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "totalPrice", label: "مبلغ" },
      ],

      allCostItem: [
        { name: "پرسنلی ", totalPrice: 0 },
        { name: "ارتباطات، حمل ونقل ، پست ، دورنویس و باربری", totalPrice: 0 },
        { name: "هزینه های پیش بینی نشده", totalPrice: 0 },
      ],
      allCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نوع هزینه‌ها" },
        { key: "پرسنلی ", label: "پرسنلی" },
      ],

      specs: {},
      chek: "",
      OrgCostItem: [],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود)",
        },
        { key: "totalPrice", label: "میزان مشارکت (تومان)" },
        { key: "operation", label: "" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        // { key: "consumable", label: "مصرفی" },
        // { key: "fund", label: "سرمایه‌ای" },
        { key: "type", label: "نوع" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد/میزان" },
        { key: "perPrice", label: "قیمت واحد به تومان" },
        { key: "totalPrice", label: "قیمت کل به تومان" },
        { key: "operation", label: "" },
      ],

      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
        { key: "operation", label: "" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        // { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه کل سفر" },
        { key: "operation", label: "" },
      ],
      perCosts: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      perPrices: [
        {
          value: "دلار",
          text: "دلار",
        },
        {
          value: "تومان",
          text: "تومان",
        },
      ],
      options1: [
        {
          value: "کارشناسی",
          text: "کارشناسی",
        },
        {
          value: "کارشناسی ارشد",
          text: "کارشناسی ارشد",
        },
        {
          value: "دکتری",
          text: "دکتری",
        },
      ],
      options2: [
        {
          value: "تمام وقت",
          text: "تمام وقت",
        },
        {
          value: "پاره وقت",
          text: "پاره وقت",
        },
      ],
      sources: [
        {
          value: "داخلی",
          text: "داخلی",
        },
        {
          value: "خارجی",
          text: "خارجی",
        },
      ],
      deviceTypes: [
        { value: "مصرفی", text: "مصرفی" },
        { value: "سرمایه‌ای", text: "سرمایه‌ای" },
      ],
      PersonnelCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام و نام خانوادگی" },
        { key: "degree", label: "میزان تحصیلات" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "cooperationHour", label: "هزینه نفر ساعت (تومان)" },
        { key: "perPersonCost", label: "نفر ساعت مورد نیاز" },
        {
          key: "humanResourceCost",
          label: "هزینه نیروی انسانی (تومان)",
        },
        { key: "operation", label: "" },
      ],
      gettingMobile: false,
      initial: {},
      companies: [],
      accelerators: [],
      colleaguesData: [],
      serviceItems: [],
      promises: {},
      selectedColleague: "",
      executor: {},
      iran: [],
      proposal: {
        initialIsSupported: null,
        obligations: [],
      },

      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      colleague: {},
      eduGradeOptions: [
        { text: "--مقطع را انتخاب کنید", disabled: true },
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      otherUniversity: "",
      mehvars: [],
      otherMehvars: "",
      achievmentitems: [],
      uploadedFiles: new Array(7).fill({
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      }),
      // uploadedFiles: [{
      //   file:null,
      //   isUploaded: false,
      //   uploadPercentage: 0,
      // },
      // {
      //   file:null,
      //   isUploaded: false,
      //   uploadPercentage: 0,
      // },
      // {
      //   file:null,
      //   isUploaded: false,
      //   uploadPercentage: 0,
      // },
      // {
      //   file:null,
      //   isUploaded: false,
      //   uploadPercentage: 0,
      // },
      // {
      //   file:null,
      //   isUploaded: false,
      //   uploadPercentage: 0,
      // },
      // {
      //   file:null,
      //   isUploaded: false,
      //   uploadPercentage: 0,
      // },
      // {
      //   file:null,
      //   isUploaded: false,
      //   uploadPercentage: 0,
      // }
      // ],
      files: [
        {
          showName: "",
          url: "",
          id: "",
          title: "",
        },
        {
          showName: "",
          url: "",
          id: "",
          title: "",
        },
        {
          showName: "",
          url: "",
          id: "",
          title: "",
        },
        {
          showName: "",
          url: "",
          id: "",
          title: "",
        },
        {
          showName: "",
          url: "",
          id: "",
          title: "",
        },
        {
          showName: "",
          url: "",
          id: "",
          title: "",
        },
        {
          showName: "",
          url: "",
          id: "",
          title: "",
        },
      ],

      isSaving: false,
      selectedReviewer: {},
      color: "",
      tabIndex: 1,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      isLoaded: true,
      showTop: false,
      reactivity2: false,
    };
  },

  methods: {
    viewList(type) {
      localStorage.setItem("list", type);
      let link = "/map";
      window.open(link, "_blank");
    },
    Export2Doc(element, filename = "") {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><link rel='stylesheet' href='https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css' integrity='sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z' crossorigin='anonymous'><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} .all{direction : rtl; text-align: right}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    removeMehvar() {
      this.proposal.mehvarId = "";
      this.otherMehvars = "";
    },
    nameKeydown(evt) {
      if (/[^a-zA-Z 0-9]/.test(evt)) {
        e.preventDefault();
      }
    },
    changedStartDate(data, index) {
      if (
        moment(data.startDate, "jYYYY/jM/JD").format("X") >
        moment(data.dueDate, "jYYYY/jM/JD").format("X")
      ) {
        this.serviceItems[index].dueDate = this.computedMinDate(data.startDate);
      }
    },
    computedMaxDate(dueDate) {
      // REVIEW (m-computedMaxDate)
      let m = moment(dueDate, "jYYYY/jM/jD");
      m.subtract(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    computedMinDate(startDate) {
      // REVIEW (m-computedMinDate)
      let m = moment(startDate, "jYYYY/jM/jD");
      m.add(1, "day");

      return m.format("jYYYY/jM/jDD");
    },
    conditionalSelect(option, type) {
      // NOTE (m-conditionalSelect) to choose from options related to university informations
      if (option.text == "--گزینه مورد نظر خود را انتخاب نمایید--") {
        switch (type) {
          case "Cjob":
            this.proposal.universityJob = "";
            break;
          case "Cedu":
            this.proposal.university = "";
            break;
          case "Ejob":
            this.proposal.universityJob = "";
            break;
          case "Eedu":
            this.proposal.universityId = "";
            break;
          case "Elast":
            this.proposal.researcherLastDegree = "";
            break;
          case "Clast":
            this.proposal.researcherLastDegree = "";
            break;
          case "Rlast":
            this.reviewer.researcherLastDegree = "";
            break;
        }
      }
      this.$forceUpdate();
    },
    isEmail(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? null : false) : null;
    },
    isEmailClass(email) {
      // NOTE (m-isEmail) to check the validity of the email
      return email ? (this.validateEmail(email) ? true : false) : false;
    },
    isID(id) {
      // NOTE to check the validity of the national code
      return id ? (this.checkCodeMeli(id) ? null : false) : null;
    },
    isIdClass(id) {
      return id ? (this.checkCodeMeli(id) ? true : false) : false;
    },
    changePage(direction) {
      // NOTE (m-changePage) to go to the previous and next step in each step
      direction == "back" ? this.tabIndex-- : this.tabIndex++;

      // Scroll to Top
      window.scrollTo(0, 0);
      ////////////////

      // save draft !!!
      this.saveDraft();
      ////////////////
    },
    addAchievment() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.proposal.requestProducts.push({
        name: "",
        amount: "",
        fullfill: "",
      });
      const title = (
        <div>
          <h5>!دستاورد جدید افزوده شد</h5>
          <span>لطفا اطلاعات دستاورد جدید را در جدول مربوطه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    addOrgCost() {
      // NOTE (m-addOrgCost) to add organization costs in the relevant sections
      this.proposal.participationOrganizationBudget.push({
        name: "",
        description: "",
        totalPrice: 0,
      });
      const title = (
        <div>
          <h5>!هزینه جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هزینه‌های همکاری با موسسات را در جدول مربوطه تکمیل کنید
          </span>
        </div>
      );
      this.toast(title, "info");
    },
    addDeviceCost() {
      // NOTE (m-addDeviceCost) to add device costs in the relevant sections
      this.proposal.purchases.push({
        name: "",
        // consumable: "",
        // fund: 0,
        type: "",
        source: "",
        number: 0,
        perPrice: 0,
        totalPrice: 0,
      });
      const title = (
        <div>
          <h5>!هزینه جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هزینه‌های تجهیزات را در جدول مربوطه تکمیل کنید
          </span>
        </div>
      );
      this.toast(title, "info");
    },
    getMobile() {
      this.gettingMobile = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/profile/mobile",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.gettingMobile = false;
          this.proposal.researcherMobile = res.data;
        })
        .catch((err) => {
          this.gettingMobile = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    addCost1() {
      // NOTE (m-addCost1) to add personnel costs in the relevant sections
      this.proposal.personnelCosts.push({
        name: "",
        degree: "",
        cooperationType: "",
        cooperationHour: 0,
        perPersonCost: 0,
      });
      const title = (
        <div>
          <h5>!هزینه جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هزینه‌های تجهیزات را در جدول مربوطه تکمیل کنید
          </span>
        </div>
      );
      this.toast(title, "info");
    },
    addService() {
      // NOTE (m-addService) to add service costs in the relevant sections
      this.proposal.gantData.push({
        description: "",
        percent: 0,
        startDate: moment(new Date()).format("jYYYY/jMM/jDD"),
        dueDate: moment(new Date()).add(1, "day").format("jYYYY/jMM/jDD"),
        cellColor: "blue",
        report: false,
      });
      const title = (
        <div>
          <h5>!فاز جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هر فاز را در جدول مربوطه تکمیل کنید و به منظور
            بروزرسانی گانت چارت روی دکمه بروزرسانی کلیک کنید
          </span>
        </div>
      );
      this.toast(title, "info");
      this.myshow = !this.myshow;
    },
    addTripCost() {
      // NOTE (m-addTripCost) to add trip costs in the relevant sections
      this.proposal.travelExpenses.push({
        destination: "",
        reason: "",
        number: "",
        // day: "",
        cost: 0,
      });
      const title = (
        <div>
          <h5>!هزینه جدید افزوده شد</h5>
          <span>
            لطفا اطلاعات هزینه‌های تجهیزات را در جدول مربوطه تکمیل کنید
          </span>
        </div>
      );
      this.toast(title, "info");
    },
    delCost1(order) {
      // NOTE (m-delCost1) to romove personnel costs in the relevant sections
      if (this.proposal.personnelCosts.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد هزینه باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.proposal.personnelCosts.splice(order, 1);
      }
    },
    delTripCost(order) {
      // NOTE (m-delTripCost) to remove trip costs in the relevant sections
      this.proposal.travelExpenses.splice(order, 1);
    },
    delAchievment(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      if (this.proposal.requestProducts.length == 1) {
        const title = (
          <div>
            <h5>!خطا</h5>
            <span>حداقل یک فیلد دستاورد باید موجود باشد</span>
          </div>
        );
        this.toast(title, "error");
      } else {
        this.proposal.requestProducts.splice(order, 1);
      }
    },
    delService(order) {
      // NOTE (m-delService) to remove services in the relevant sections
      this.proposal.gantData.splice(order, 1);
    },
    delDeviceCost(order) {
      // NOTE (m-delDeviceCost) to remove device costs in the relevant sections
      this.proposal.purchases.splice(order, 1);
    },
    delOrgCost(order) {
      // NOTE (m-delOrgCost) to remove organization costs in the relevant sections
      this.proposal.participationOrganizationBudget.splice(order, 1);
    },
    addColleague() {
      // NOTE (m-addColleague) to add colleagues in the relevant sections
      this.proposal.colleagues.push(
        new Object({
          uploadPercentage: 0,
          isUploaded: false,
          file: null,
          resumeFile: null,
        })
      );
      const title = (
        <div>
          <h5>!همکار جدید افزوده شد</h5>
          <span>لطفا اطلاعات همکار جدید را در همین صفحه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
      this.$forceUpdate();
    },
    addReviewer() {
      // NOTE (m-addReviewer) to add reviewers in the relevant sections
      this.proposal.reviewers.push(
        new Object({
          uploadPercentage: 0,
        })
      );
      const title = (
        <div>
          <h5>!داور جدید افزوده شد</h5>
          <span>لطفا اطلاعات داور جدید را در همین صفحه تکمیل کنید</span>
        </div>
      );
      this.toast(title, "info");
    },
    deleteReviewer(index) {
      // NOTE (m-deleteReviewer) to assign a number to the selected reviewer to be removed
      this.selectedReviewer = index;
      this.$refs["delReviewer"].show();
    },
    deleteColleague(index) {
      // NOTE (m-deleteColleague) to assign a number to the selected colleagues to be removed
      this.selectedColleague = index;
      this.$refs["delColleague"].show();
    },
    hideModal(type) {
      // NOTE (modal) to hide modal
      this.$refs[type].hide();
    },
    doDeleteColleague() {
      // NOTE (m-deleteColleague) to remove the selected colleague
      this.colleaguesData.splice(this.selectedColleague, 1);
      this.proposal.colleagues.splice(this.selectedColleague, 1);
      this.selectedColleague = "";
      this.$refs["delColleague"].hide();
    },
    doDeleteReviewer() {
      // NOTE (m-deleteReviewer) to remove the selected reviewer
      this.proposal.reviewers.splice(this.selectedReviewer, 1);
      this.selectedReviewer = "";
      this.$refs["delReviewer"].hide();
    },
    uploadFile(file, index, fileName) {
      // NOTE to upload files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.uploadedFiles[index].showProgress = true;
        this.uploadedFiles[index].variant = "info";
        this.uploadedFiles[index].uploadPercentage = 0;
        this.uploadedFiles[index].isUploaded = false;
        this.uploadedFiles[index].uploadButDisable = true;

        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/researcher/request/project/upload?requestId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.uploadedFiles[index].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.uploadedFiles[index].isUploaded = true;
              this.uploadedFiles[index].uploadPercentage = 100;
              this.uploadedFiles[index].striped = false;
              this.uploadedFiles[index].variant = "success";
              this.uploadedFiles[index].uploadButDisable = false;
              this.proposal[fileName] = d.data.url;
              this.proposal[fileName + "Id"] = d.data.id;
              this.files[index] = d.data;
              this.files[index].title = this.fileTitles[index];

              // this.uploadedFiles[index].title = d.data[0].showName;
              // this.uploadedFiles[index].description =
              //   this.descriptionTemplates[index].description;

              // this.research = this.uploadedFiles[1]
              //   ? this.uploadedFiles[1].name
              //   : false;
              // this.industry = this.uploadedFiles[2]
              //   ? this.uploadedFiles[2].name
              //   : false;
              // this.agreement = this.uploadedFiles[3]
              //   ? this.uploadedFiles[3].name
              //   : false;
              // this.account = this.uploadedFiles[7]
              //   ? this.uploadedFiles[7].name
              //   : false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles[index].uploadPercentage = 0;
            this.uploadedFiles[index].isUploaded = false;
          });
      }
    },
    colUploadFile(file, index) {
      // NOTE  to upload colleagues files
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.proposal.colleagues[index].showProgress = true;
        this.proposal.colleagues[index].variant = "info";
        this.proposal.colleagues[index].uploadPercentage = 0;
        this.proposal.colleagues[index].isUploaded = false;
        this.proposal.colleagues[index].uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/researcher/request/project/upload?requestId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.proposal.colleagues.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((d) => {
            if (d.status == 200) {
              this.proposal.colleagues[index].resumeFile = d.data.url;
              this.proposal.colleagues[index].isUploaded = true;
              this.proposal.colleagues[index].uploadPercentage = 100;
              this.proposal.colleagues[index].striped = false;
              this.proposal.colleagues[index].variant = "success";
              this.proposal.colleagues[index].uploadButDisable = false;
              this.proposal.colleagues[index].resumeFileId = d.data.id;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.proposal.colleagues[index].file = null;
            this.proposal.colleagues[index].uploadPercentage = 0;
            this.proposal.colleagues[index].isUploaded = false;
          });
      }
    },
    submitProposal() {
      // NOTE (m-submitProposal) to submit proposal
      // REVIEW
      this.$bvModal.show("loading");
      this.isLoaded = false;

      if (this.proposal.revision > 0) {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/project/edit",
            {
              requestId: this.$route.params.id,
              uploadedFiles: this.files,
              colleagues: this.proposal.colleagues,
              enSubject: this.proposal.enSubject,
              faSubject: this.proposal.faSubject,
              initialIsSupported: this.proposal.initialIsSupported,
              initialSupportedType: this.proposal.initialSupportedType,
              initialOtherSupport: this.proposal.initialOtherSupport,
              initialSupportDescription:
                this.proposal.initialSupportDescription,
              universityId: this.proposal.universityId,
              otherUniversity: this.proposal.otherUniversity,
              mehvarId: this.proposal.mehvarId,
              otherMehvars: this.proposal.otherMehvars,
              typeStudy: this.proposal.typeStudy,
              typeSystemicDevelopmental:
                this.proposal.typeSystemicDevelopmental,
              typePractical: this.proposal.typePractical,
              zoneMedicine: this.proposal.zoneMedicine,
              zoneAgriculture: this.proposal.zoneAgriculture,
              zoneEnvironment: this.proposal.zoneEnvironment,
              zoneIndustrial: this.proposal.zoneIndustrial,
              zoneBioComputing: this.proposal.zoneBioComputing,
              zoneOther: this.proposal.zoneOther,
              researcherUniversityId: this.proposal.researcherUniversityId,
              researcherUniversityOther:
                this.proposal.researcherUniversityOther,
              researcherResearch: this.proposal.researcherResearch,
              researcherIndustry: this.proposal.researcherIndustry,
              researcherName: this.proposal.researcherName,
              researcherMobile: this.proposal.researcherMobile,
              researcherEmail: this.proposal.researcherEmail,
              researcherNatCode: this.proposal.researcherNatCode,
              researcherFax: this.proposal.researcherFax,
              researcherCityId: this.proposal.researcherCityId ? this.proposal.researcherCityId : null,
              researcherStateId: this.proposal.researcherStateId ? this.proposal.researcherStateId : null,
              researcherLastDegree: this.proposal.researcherLastDegree,
              abstract: this.proposal.abstract,
              requestNecessity: this.proposal.requestNecessity,
              majorGoals: this.proposal.majorGoals,
              minorGoals: this.proposal.minorGoals,
              benefitsToCountry: this.proposal.benefitsToCountry,
              methodology: this.proposal.methodology,
              requestProducts: this.proposal.requestProducts,
              executionHistorySimilar: this.proposal.executionHistorySimilar,
              internationalPartners: this.proposal.internationalPartners,
              references: this.proposal.references,
              commercializingType: this.proposal.commercializingType,
              companyId:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyId
                  : "",
              otherCompanyName:
                this.proposal.commercializingType == "company" &&
                this.proposal.companyId == this.notCompany
                  ? this.proposal.otherCompanyName
                  : "",
              companyName:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyName
                  : "",
              companyNationalId:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyNationalId
                  : "",
              companyRegistrationNumber:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyRegistrationNumber
                  : "",
              otherCompanyRegistrationNumber:
                this.proposal.commercializingType == "company" &&
                this.proposal.companyId == this.notCompany
                  ? this.proposal.otherCompanyRegistrationNumber
                  : "",
              otherCompanyNationalId:
                this.proposal.commercializingType == "company" &&
                this.proposal.companyId == this.notCompany
                  ? this.proposal.otherCompanyNationalId
                  : "",
              companyProducts:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyProducts
                  : "",
              companyContactInfo:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyContactInfo
                  : "",
              interactUniversityCenters:
                this.proposal.interactUniversityCenters,
              targetMarket: this.proposal.targetMarket,
              estimationProductionProjectRevenue:
                this.proposal.estimationProductionProjectRevenue,
              employment: this.proposal.employment,
              durationCooperation: this.proposal.durationCooperation,
              productSalesForecast: this.proposal.productSalesForecast,
              estimationProductionProjectRevenue:
                this.proposal.estimationProductionProjectRevenue,
              competitiveProductsLevelCompetitiveness:
                this.proposal.competitiveProductsLevelCompetitiveness,
              productAdvantages: this.proposal.productAdvantages,
              acceleratorId:
                this.proposal.commercializingType == "accelerator"
                  ? this.proposal.acceleratorId
                  : "",
              commercializingObligation1:
                this.proposal.commercializingType == "none"
                  ? this.proposal.commercializingObligation1
                  : "",
              commercializingObligation2:
                this.proposal.commercializingType == "none"
                  ? this.proposal.commercializingObligation2
                  : "",
              gantData: this.proposal.gantData,
              personnelCosts: this.proposal.personnelCosts,
              budget:
                parseInt(
                  this.proposal.personnelCosts.length == 0
                    ? 0
                    : this.proposal.personnelCosts
                        .map(
                          (x) =>
                            parseInt(x.perPersonCost) *
                            parseInt(x.cooperationHour)
                        )
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                ) +
                parseInt(
                  this.proposal.travelExpenses.length == 0
                    ? 0
                    : this.proposal.travelExpenses
                        .map((x) => x.cost)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                ) +
                parseInt(
                  this.proposal.otherCosts.length == 0
                    ? 0
                    : this.proposal.otherCosts
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                ) +
                parseInt(
                  this.proposal.purchases.length == 0
                    ? 0
                    : this.proposal.purchases
                        .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                ),
              letterUniversityResearchFile:
                this.proposal.letterUniversityResearchFile,
              letterUniversityResearchFileId:
                this.proposal.letterUniversityResearchFileId,
              letterCompanyFileId: this.proposal.letterCompanyFileId,
              universityAgreementIndustryFileId:
                this.proposal.universityAgreementIndustryFileId,
              letterUniversityAccountNumberFileId:
                this.proposal.letterUniversityAccountNumberFileId,
              promiseArrays: this.proposal.promiseArrays,
              researcherLastName: this.proposal.researcherLastName,
              researcherUniversityJobId:
                this.proposal.researcherUniversityJobId,
              researcherUniversityJobOther:
                this.proposal.researcherUniversityJobOther,
              duration: this.proposal.duration,
              startDate: this.proposal.startDate,
              finalDate: this.proposal.finalDate,
              travelExpenses: this.proposal.travelExpenses,
              purchases: this.proposal.purchases,
              participationOrganizationBudget:
                this.proposal.participationOrganizationBudget,
              otherCosts: this.proposal.otherCosts,
              otherFile1Id: this.proposal.otherFile1Id,
              otherFile1Title: this.proposal.otherFile1Title,
              otherFile1Description: this.proposal.otherFile1Description,
              otherFile2Id: this.proposal.otherFile2Id,
              otherFile2Title: this.proposal.otherFile2Title,
              otherFile2Description: this.proposal.otherFile2Description,
              otherFile3Id: this.proposal.otherFile3Id,
              otherFile3Title: this.proposal.otherFile3Title,
              otherFile3Description: this.proposal.otherFile3Description,
              reviewers: this.proposal.reviewers,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            router.push("/researcher/proposal/" + this.$route.params.id);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          });
      } else {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/request/project/submit",
            {
              requestId: this.$route.params.id,
              uploadedFiles: this.files,
              colleagues: this.proposal.colleagues,
              enSubject: this.proposal.enSubject,
              faSubject: this.proposal.faSubject,
              initialIsSupported: this.proposal.initialIsSupported,
              initialSupportedType: this.proposal.initialSupportedType,
              initialOtherSupport: this.proposal.initialOtherSupport,
              initialSupportDescription:
                this.proposal.initialSupportDescription,
              universityId: this.proposal.universityId,
              otherUniversity: this.proposal.otherUniversity,
              mehvarId: this.proposal.mehvarId,
              otherMehvars: this.proposal.otherMehvars,
              typeStudy: this.proposal.typeStudy,
              typeSystemicDevelopmental:
                this.proposal.typeSystemicDevelopmental,
              typePractical: this.proposal.typePractical,
              zoneMedicine: this.proposal.zoneMedicine,
              zoneAgriculture: this.proposal.zoneAgriculture,
              zoneEnvironment: this.proposal.zoneEnvironment,
              zoneIndustrial: this.proposal.zoneIndustrial,
              zoneBioComputing: this.proposal.zoneBioComputing,
              zoneOther: this.proposal.zoneOther,
              researcherUniversityId: this.proposal.researcherUniversityId,
              researcherUniversityOther:
                this.proposal.researcherUniversityOther,
              researcherResearch: this.proposal.researcherResearch,
              researcherIndustry: this.proposal.researcherIndustry,
              researcherName: this.proposal.researcherName,
              researcherMobile: this.proposal.researcherMobile,
              researcherEmail: this.proposal.researcherEmail,
              researcherNatCode: this.proposal.researcherNatCode,
              researcherFax: this.proposal.researcherFax,
              researcherCityId: this.proposal.researcherCityId ? this.proposal.researcherCityId : null,
              researcherStateId: this.proposal.researcherStateId ? this.proposal.researcherStateId : null,
              researcherLastDegree: this.proposal.researcherLastDegree,
              abstract: this.proposal.abstract,
              requestNecessity: this.proposal.requestNecessity,
              majorGoals: this.proposal.majorGoals,
              minorGoals: this.proposal.minorGoals,
              benefitsToCountry: this.proposal.benefitsToCountry,
              methodology: this.proposal.methodology,
              requestProducts: this.proposal.requestProducts,
              executionHistorySimilar: this.proposal.executionHistorySimilar,
              internationalPartners: this.proposal.internationalPartners,
              references: this.proposal.references,
              commercializingType: this.proposal.commercializingType,
              companyId:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyId
                  : "",
              otherCompanyName:
                this.proposal.commercializingType == "company" &&
                this.proposal.companyId == this.notCompany
                  ? this.proposal.otherCompanyName
                  : "",
              companyName:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyName
                  : "",
              companyNationalId:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyNationalId
                  : "",
              companyRegistrationNumber:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyRegistrationNumber
                  : "",
              otherCompanyRegistrationNumber:
                this.proposal.commercializingType == "company" &&
                this.proposal.companyId == this.notCompany
                  ? this.proposal.otherCompanyRegistrationNumber
                  : "",
              otherCompanyNationalId:
                this.proposal.commercializingType == "company" &&
                this.proposal.companyId == this.notCompany
                  ? this.proposal.otherCompanyNationalId
                  : "",
              companyProducts:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyProducts
                  : "",
              companyContactInfo:
                this.proposal.commercializingType == "company"
                  ? this.proposal.companyContactInfo
                  : "",
              interactUniversityCenters:
                this.proposal.interactUniversityCenters,
              targetMarket: this.proposal.targetMarket,
              estimationProductionProjectRevenue:
                this.proposal.estimationProductionProjectRevenue,
              employment: this.proposal.employment,
              durationCooperation: this.proposal.durationCooperation,
              productSalesForecast: this.proposal.productSalesForecast,
              estimationProductionProjectRevenue:
                this.proposal.estimationProductionProjectRevenue,
              competitiveProductsLevelCompetitiveness:
                this.proposal.competitiveProductsLevelCompetitiveness,
              productAdvantages: this.proposal.productAdvantages,
              acceleratorId:
                this.proposal.commercializingType == "accelerator"
                  ? this.proposal.acceleratorId
                  : "",
              commercializingObligation1:
                this.proposal.commercializingType == "none"
                  ? this.proposal.commercializingObligation1
                  : "",
              commercializingObligation2:
                this.proposal.commercializingType == "none"
                  ? this.proposal.commercializingObligation2
                  : "",
              gantData: this.proposal.gantData,

              personnelCosts: this.proposal.personnelCosts,
              budget:
                parseInt(
                  this.proposal.personnelCosts.length == 0
                    ? 0
                    : this.proposal.personnelCosts
                        .map(
                          (x) =>
                            parseInt(x.perPersonCost) *
                            parseInt(x.cooperationHour)
                        )
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                ) +
                parseInt(
                  this.proposal.travelExpenses.length == 0
                    ? 0
                    : this.proposal.travelExpenses
                        .map((x) => x.cost)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                ) +
                parseInt(
                  this.proposal.otherCosts.length == 0
                    ? 0
                    : this.proposal.otherCosts
                        .map((x) => x.totalPrice)
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                ) +
                parseInt(
                  this.proposal.purchases.length == 0
                    ? 0
                    : this.proposal.purchases
                        .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                ),
              letterUniversityResearchFile:
                this.proposal.letterUniversityResearchFile,
              letterUniversityResearchFileId:
                this.proposal.letterUniversityResearchFileId,
              letterCompanyFileId: this.proposal.letterCompanyFileId,
              universityAgreementIndustryFileId:
                this.proposal.universityAgreementIndustryFileId,
              letterUniversityAccountNumberFileId:
                this.proposal.letterUniversityAccountNumberFileId,
              promiseArrays: this.proposal.promiseArrays,
              researcherLastName: this.proposal.researcherLastName,
              researcherUniversityJobId:
                this.proposal.researcherUniversityJobId,
              researcherUniversityJobOther:
                this.proposal.researcherUniversityJobOther,
              duration: this.proposal.duration,
              startDate: this.proposal.startDate,
              finalDate: this.proposal.finalDate,
              travelExpenses: this.proposal.travelExpenses,
              purchases: this.proposal.purchases,
              participationOrganizationBudget:
                this.proposal.participationOrganizationBudget,
              otherCosts: this.proposal.otherCosts,
              otherFile1Id: this.proposal.otherFile1Id,
              otherFile1Title: this.proposal.otherFile1Title,
              otherFile1Description: this.proposal.otherFile1Description,
              otherFile2Id: this.proposal.otherFile2Id,
              otherFile2Title: this.proposal.otherFile2Title,
              otherFile2Description: this.proposal.otherFile2Description,
              otherFile3Id: this.proposal.otherFile3Id,
              otherFile3Title: this.proposal.otherFile3Title,
              otherFile3Description: this.proposal.otherFile3Description,
              reviewers: this.proposal.reviewers,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.toast(res.data, "success");
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            router.push("/researcher/proposal/" + this.$route.params.id);
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          });
      }
    },
    delFile(order, fileName) {
      this.uploadedFiles[order] = {
        file: null,
        isUploaded: false,
        uploadPercentage: 0,
      };
      this.files[order] = {
        showName: "",
        url: "",
        id: "",
      };
      this.proposal[fileName] = "";
      this.proposal[fileName + "Id"] = "";
    },
    saveDraft() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.showTop = true;
      // NOTE (m-saveDraft) to save drafts in each step
      this.isSaving = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/project/draft",
          {
            requestId: this.$route.params.id,
            uploadedFiles: this.files,
            colleagues: this.proposal.colleagues,
            enSubject: this.proposal.enSubject,
            faSubject: this.proposal.faSubject,
            initialIsSupported: this.proposal.initialIsSupported,
            initialSupportedType: this.proposal.initialSupportedType,
            initialOtherSupport: this.proposal.initialOtherSupport,
            initialSupportDescription: this.proposal.initialSupportDescription,
            universityId: this.proposal.universityId,
            otherUniversity: this.proposal.otherUniversity,
            mehvarId: this.proposal.mehvarId,
            otherMehvars: this.proposal.otherMehvars,
            typeStudy: this.proposal.typeStudy,
            typeSystemicDevelopmental: this.proposal.typeSystemicDevelopmental,
            typePractical: this.proposal.typePractical,
            zoneMedicine: this.proposal.zoneMedicine,
            zoneAgriculture: this.proposal.zoneAgriculture,
            zoneEnvironment: this.proposal.zoneEnvironment,
            zoneIndustrial: this.proposal.zoneIndustrial,
            zoneBioComputing: this.proposal.zoneBioComputing,
            zoneOther: this.proposal.zoneOther,
            researcherUniversityId: this.proposal.researcherUniversityId,
            researcherUniversityOther: this.proposal.researcherUniversityOther,
            researcherResearch: this.proposal.researcherResearch,
            researcherIndustry: this.proposal.researcherIndustry,
            researcherName: this.proposal.researcherName,
            researcherMobile: this.proposal.researcherMobile,
            researcherEmail: this.proposal.researcherEmail,
            researcherNatCode: this.proposal.researcherNatCode,
            researcherFax: this.proposal.researcherFax,
            researcherCityId: this.proposal.researcherCityId ? this.proposal.researcherCityId : null,
            researcherStateId: this.proposal.researcherStateId ? this.proposal.researcherStateId : null,
            researcherLastDegree: this.proposal.researcherLastDegree,
            abstract: this.proposal.abstract,
            requestNecessity: this.proposal.requestNecessity,
            majorGoals: this.proposal.majorGoals,
            minorGoals: this.proposal.minorGoals,
            benefitsToCountry: this.proposal.benefitsToCountry,
            methodology: this.proposal.methodology,
            requestProducts: this.proposal.requestProducts,
            executionHistorySimilar: this.proposal.executionHistorySimilar,
            internationalPartners: this.proposal.internationalPartners,
            references: this.proposal.references,
            commercializingType: this.proposal.commercializingType,
            companyId:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyId
                : "",
            otherCompanyName:
              this.proposal.commercializingType == "company" &&
              this.proposal.companyId == this.notCompany
                ? this.proposal.otherCompanyName
                : "",
            companyName:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyName
                : "",
            companyNationalId:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyNationalId
                : "",
            companyRegistrationNumber:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyRegistrationNumber
                : "",
            otherCompanyRegistrationNumber:
              this.proposal.commercializingType == "company" &&
              this.proposal.companyId == this.notCompany
                ? this.proposal.otherCompanyRegistrationNumber
                : "",
            otherCompanyNationalId:
              this.proposal.commercializingType == "company" &&
              this.proposal.companyId == this.notCompany
                ? this.proposal.otherCompanyNationalId
                : "",
            companyProducts:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyProducts
                : "",
            companyContactInfo:
              this.proposal.commercializingType == "company"
                ? this.proposal.companyContactInfo
                : "",
            interactUniversityCenters: this.proposal.interactUniversityCenters,
            targetMarket: this.proposal.targetMarket,
            estimationProductionProjectRevenue:
              this.proposal.estimationProductionProjectRevenue,
            employment: this.proposal.employment,
            durationCooperation: this.proposal.durationCooperation,
            productSalesForecast: this.proposal.productSalesForecast,
            estimationProductionProjectRevenue:
              this.proposal.estimationProductionProjectRevenue,
            competitiveProductsLevelCompetitiveness:
              this.proposal.competitiveProductsLevelCompetitiveness,
            productAdvantages: this.proposal.productAdvantages,
            acceleratorId:
              this.proposal.commercializingType == "accelerator"
                ? this.proposal.acceleratorId
                : "",
            commercializingObligation1:
              this.proposal.commercializingType == "none"
                ? this.proposal.commercializingObligation1
                : "",
            commercializingObligation2:
              this.proposal.commercializingType == "none"
                ? this.proposal.commercializingObligation2
                : "",
            gantData: this.proposal.gantData,
            personnelCosts: this.proposal.personnelCosts,
            budget:
              parseInt(
                this.proposal.personnelCosts.length == 0
                  ? 0
                  : this.proposal.personnelCosts
                      .map(
                        (x) =>
                          parseInt(x.perPersonCost) *
                          parseInt(x.cooperationHour)
                      )
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
              ) +
              parseInt(
                this.proposal.travelExpenses.length == 0
                  ? 0
                  : this.proposal.travelExpenses
                      .map((x) => x.cost)
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
              ) +
              parseInt(
                this.proposal.otherCosts.length == 0
                  ? 0
                  : this.proposal.otherCosts
                      .map((x) => x.totalPrice)
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
              ) +
              parseInt(
                this.proposal.purchases.length == 0
                  ? 0
                  : this.proposal.purchases
                      .map((x) => parseInt(x.perPrice) * parseInt(x.number))
                      .reduce((a, b) => parseInt(a) + parseInt(b), 0)
              ),
            letterUniversityResearchFile:
              this.proposal.letterUniversityResearchFile,
            letterUniversityResearchFileId:
              this.proposal.letterUniversityResearchFileId,
            letterCompanyFileId: this.proposal.letterCompanyFileId,
            universityAgreementIndustryFileId:
              this.proposal.universityAgreementIndustryFileId,
            letterUniversityAccountNumberFileId:
              this.proposal.letterUniversityAccountNumberFileId,
            promiseArrays: this.proposal.promiseArrays,
            researcherLastName: this.proposal.researcherLastName,
            researcherUniversityJobId: this.proposal.researcherUniversityJobId,
            researcherUniversityJobOther:
              this.proposal.researcherUniversityJobOther,
            duration:
              this.proposal.gantData.length > 0
                ? (Math.max(
                    ...this.proposal.gantData.map((x) =>
                      new Date(
                        moment(x.dueDate, "jYYYY/jMM/jDD").format("YYYY-MM-DD")
                      ).getTime()
                    )
                  ) -
                    Math.min(
                      ...this.proposal.gantData.map((x) =>
                        new Date(
                          moment(x.startDate, "jYYYY/jMM/jDD").format(
                            "YYYY-MM-DD"
                          )
                        ).getTime()
                      )
                    )) /
                  3600 /
                  24 /
                  1000
                : "",
            startDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.min(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.startDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",
            finalDate:
              this.proposal.gantData.length > 0
                ? moment(
                    new Date(
                      Math.max(
                        ...this.proposal.gantData.map((x) =>
                          new Date(
                            moment(x.dueDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      )
                    )
                  ).format("jYYYY/jMM/jDD")
                : "",
            travelExpenses: this.proposal.travelExpenses,
            purchases: this.proposal.purchases,
            participationOrganizationBudget:
              this.proposal.participationOrganizationBudget,
            otherCosts: this.proposal.otherCosts,
            otherFile1Id: this.proposal.otherFile1Id,
            otherFile1Title: this.proposal.otherFile1Title,
            otherFile1Description: this.proposal.otherFile1Description,
            otherFile2Id: this.proposal.otherFile2Id,
            otherFile2Title: this.proposal.otherFile2Title,
            otherFile2Description: this.proposal.otherFile2Description,
            otherFile3Id: this.proposal.otherFile3Id,
            otherFile3Title: this.proposal.otherFile3Title,
            otherFile3Description: this.proposal.otherFile3Description,
            reviewers: this.proposal.reviewers,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          // this.toast(res.data, "success");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          this.isSaving = false;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          setTimeout(() => {
            this.showTop = false;
          }, 2000);
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
    onMounted() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.uploadedFiles = JSON.parse(JSON.stringify(this.uploadedFiles));
      this.files = JSON.parse(JSON.stringify(this.files));
      let acc = 0;

      this.$http
        .post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.universities = res.data;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه ها",
            })
          );
          this.universities.unshift({
            id: 0,
            text: "--گزینه مورد نظر خود را انتخاب نمایید--",
            disabled: "true",
          });

          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");

              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      this.$http
        .post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
          // this.mehvars.push(
          //   new Object({
          //     id: this.notMehvar,
          //     text: "سایر محورها",
          //     universityId: this.notUniversity
          //   })
          // );
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      /////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/companies",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.companies = res.data;
          this.companies.forEach((x) => {
            x.text = x.name;
          });
          this.companies.push(
            new Object({
              id: this.notCompany,
              text: "سایر شرکت ها",
            })
          );
          acc++;

          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
            this.$bvModal.hide("loading");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      /////////////////////////////////////////////
      this.$http
        .post(
          this.baseUrl + "/setad/options/accelerators",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.accelerators = res.data;
          this.accelerators.forEach((x) => {
            x.text = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
      //////////////////////////////////////

      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/project/getInfo",
          {
            requestId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.proposal = res.data;
          this.proposal.obligations = [];
          this.files = res.data.uploadedFiles;
          this.$bvModal.hide("loading");
          setTimeout(() => {
            this.isLoaded = true;
            this.show = true;
            this.pageLoaded = true;
          }, 200);
          this.show = false;
          acc++;
          if (acc > 2) {
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch {}
          }

          this.fileBusy = false;
        })
        .catch((err) => {
          this.notLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getStatesAndCities() {
      this.$http
        .get(this.baseUrl + "/setad/public/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getCompanyInfo() {
      if (this.proposal.companyId != this.notCompany) {
        this.proposal.companyName = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].name;
        this.proposal.companyRegistrationNumber = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].registrationNumber;
        this.proposal.companyNationalId = this.companies.filter(
          (x) => x.id == this.proposal.companyId
        )[0].nationalId;
      }
    },
    universityClass(type) {
      if (type == "proposal") {
        if (this.proposal.universityId == this.notUniversity) {
          if (this.proposal.otherUniversity) {
            return "done";
          } else {
            return "required";
          }
        } else {
          if (this.proposal.universityId) {
            return "done";
          } else {
            return "required";
          }
        }
      } else {
        if (this.proposal.researcherUniversityId == this.notUniversity) {
          if (this.proposal.researcherUniversityOther) {
            return "done";
          } else {
            return "required";
          }
        } else {
          if (this.proposal.researcherUniversityId) {
            return "done";
          } else {
            return "required";
          }
        }
      }
    },
  },
  watch: {
    specs(val) {
      val.chekide ? (this.chek = val.chekide.split(" ").length) : "";
    },
    enName(val) {
      this.enName = val.replace(/\W/g, "");
    },
  },
  computed: {
    computedFiles() {
      let files = [];
      this.filesArray.forEach((x) => {
        if (this.proposal[x].url) {
          files.push(this.proposal[x]);
        }
      });
      return files;
    },
    // NOTE unuversity class if the university was "سایر"
    computedTotalCost() {
      let tempPrice =
        (this.proposal.personnelCosts.length == 0
          ? 0
          : this.proposal.personnelCosts
              .map(
                (x) => parseInt(x.perPersonCost) * parseInt(x.cooperationHour)
              )
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.travelExpenses.length == 0
          ? 0
          : this.proposal.travelExpenses
              .map((x) => x.cost)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.purchases.length == 0
          ? 0
          : this.proposal.purchases
              .map((x) => parseInt(x.perPrice) * parseInt(x.number))
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.proposal.otherCosts.length == 0
          ? 0
          : this.proposal.otherCosts
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) -
        (this.proposal.participationOrganizationBudget.length == 0
          ? 0
          : this.proposal.participationOrganizationBudget
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0));

      if (tempPrice > 0) return tempPrice;
      else return 0;
    },
    computedMehvars() {
      // NOTE (c-computedMehvars) to after selecting university show to user list of mehvars of selected university
      let mehvarha = [];
      if (this.proposal.universityId) {
        mehvarha = this.mehvars.filter(
          (x) => x.universityId == this.proposal.universityId
        );
        if (this.proposal.universityId != this.notUniversity) {
          this.proposal.mehvarId = this.proposal.mehvarId;
        } else if (this.proposal.universityId == this.notUniversity) {
          this.proposal.mehvarId = this.notMehvar;
        }
      }

      if (this.proposal.universityId) {
        mehvarha.push(
          new Object({
            id: this.notMehvar,
            text: "سایر محورها",
            universityId: this.proposal.universityId,
          })
        );
      } else {
        mehvarha.push(
          new Object({
            id: 0,
            text: "لطفا ابتدا یک دانشگاه انتخاب کنید",
            universityId: this.proposal.universityId,
          })
        );
      }
      if (this.proposal.mehvarId)
        this.selectedMehvar = mehvarha.findIndex(
          (x) => x.id == this.proposal.mehvarId
        );
      else this.selectedMehvar = "-";
      // alert(mehvarha.map(y=>y.id))
      // this.proposal.mehvarId ? this.selectedMehvar = mehvarha.map(y=>y.id).findIndexOf(this.proposal.mehvarId) : this.selectedMehvar = ''
      return mehvarha;
    },

    step1progress() {
      // NOTE (c-step1Progress) to show the percentage of basic proposal information section completion
      let progress = 0;
      this.proposal.faSubject ? progress++ : 1;
      this.proposal.enSubject ? progress++ : 1;
      if (this.proposal.mehvarId && this.proposal.mehvarId != this.notMehvar) {
        progress++;
      } else {
        if (this.proposal.mehvarId == this.notMehvar) {
          if (this.proposal.otherMehvars) {
            progress++;
          }
        }
      }

      if (this.proposal.universityId != this.notUniversity) {
        progress++;
      } else {
        if (
          this.proposal.universityId == this.notUniversity &&
          this.proposal.otherUniversity
        ) {
          progress++;
        }
      }

      this.proposal.typeStudy ||
      this.proposal.typeSystemicDevelopmental ||
      this.proposal.typePractical
        ? progress++
        : 1;
      this.proposal.zoneMedicine ||
      this.proposal.zoneAgriculture ||
      this.proposal.zoneEnvironment ||
      this.proposal.zoneIndustrial ||
      this.proposal.zoneBioComputing ||
      this.proposal.zoneOther
        ? progress++
        : 1;

      progress = parseInt((progress / 6) * 100);
      return progress;
    },
    step2progress() {
      // NOTE (c-step2Progress) previous
      let progress = 0;

      this.proposal.researcherName ? progress++ : 1;
      this.proposal.researcherLastName ? progress++ : 1;
      this.proposal.researcherNatCode &&
      this.checkCodeMeli(this.proposal.researcherNatCode)
        ? progress++
        : 1;
      this.proposal.researcherMobile ? progress++ : 1;
      this.proposal.researcherFax ? progress++ : 1;
      // this.proposal.description
      //   ? JSON.parse(this.proposal.description).fax
      //     ? progress++
      //     : 1
      //   : 1;
      this.proposal.researcherEmail &&
      this.validateEmail(this.proposal.researcherEmail)
        ? progress++
        : 1;
      this.proposal.researcherStateId ? progress++ : 1;

      this.proposal.researcherCityId ? progress++ : 1;
      // this.proposal.description
      //   ? JSON.parse(this.proposal.description).officeAddress
      //     ? progress++
      //     : 1
      //   : 1;

      // NOTE for computing percentage if the university was "سایر"
      if (this.proposal.researcherUniversityId) {
        if (this.proposal.researcherUniversityId != this.notUniversity) {
          progress++;
        } else {
          if (this.proposal.researcherUniversityOther) {
            progress++;
          }
        }
      }
      // this.proposal.universityJob || this.proposal.otherJobUniversity
      //   ? progress++
      //   : 1;
      // this.proposal.description
      //   ? JSON.parse(this.proposal.description).universityJob
      //     ? progress++
      //     : 1
      //   : 1;
      this.proposal.researcherLastDegree ? progress++ : 1;

      this.proposal.researcherResearch ? progress++ : 1;
      this.proposal.researcherIndustry ? progress++ : 1;

      progress = parseInt((progress / 12) * 100);
      return progress;
    },
    step3progress() {
      // NOTE (c-step3Progress) previous
      let progress = 0;
      if (this.proposal.colleagues.length == 0) return 100;

      this.proposal.colleagues.forEach((x) => {
        x.name ? progress++ : 1;
        x.lastName ? progress++ : 1;
        x.mobile ? progress++ : 1;
        x.natCode && this.checkCodeMeli(x.natCode) ? progress++ : 1;
        x.email && this.validateEmail(x.email) ? progress++ : 1;
        x.position ? progress++ : 1;
        // NOTE for computing percentage if the university was "سایر"
        if (x.universityId) {
          if (x.universityId != this.notUniversity) {
            progress++;
          } else {
            if (x.universityOther) {
              progress++;
            }
          }
        }
        // x.university ? progress++ : 1;
        x.lastDegree ? progress++ : 1;
        x.resumeFile ? progress++ : 1;
      });

      progress = parseInt(
        (progress / 9 / this.proposal.colleagues.length) * 100
      );
      return progress;
    },
    step4progress() {
      // NOTE (c-step4Progress) previous
      let progress = 0;
      let total = 9;
      // if (this.achievmentitems.length == 0) return 0;
      this.proposal.abstract.split(" ").length >= 200 &&
      this.proposal.abstract.split(" ").length <= 500
        ? progress++
        : 1;
      this.proposal.requestNecessity ? progress++ : 1;
      this.proposal.majorGoals ? progress++ : 1;
      this.proposal.minorGoals ? progress++ : 1;
      this.proposal.benefitsToCountry ? progress++ : 1;
      this.proposal.methodology ? progress++ : 1;

      total += this.proposal.requestProducts.length * 3;
      this.proposal.requestProducts.forEach((x) => {
        x.name ? progress++ : 1;
        x.amount ? progress++ : 1;
        x.fullfill ? progress++ : 1;
      });

      this.proposal.executionHistorySimilar ? progress++ : 1;
      this.proposal.internationalPartners ? progress++ : 1;
      this.proposal.references ? progress++ : 1;

      // progress = parseInt((progress / total) * 100);
      return total == 0 ? 0 : parseInt((progress / total) * 100);
      // return progress;
    },
    step5progress() {
      // NOTE (c-step5Progress) previous
      let progress = 0;

      this.proposal.interactUniversityCenters ? progress++ : 1;
      this.proposal.targetMarket ? progress++ : 1;
      this.proposal.estimationProductionProjectRevenue ? progress++ : 1;
      this.proposal.employment ? progress++ : 1;
      this.proposal.durationCooperation ? progress++ : 1;
      this.proposal.productSalesForecast ? progress++ : 1;
      this.proposal.competitiveProductsLevelCompetitiveness ? progress++ : 1;
      this.proposal.productAdvantages ? progress++ : 1;
      if (this.proposal.commercializingType == "company") {
        if (
          this.proposal.companyId &&
          this.proposal.companyId != this.notCompany
        ) {
          progress++;
          this.proposal.companyRegistrationNumber ? progress++ : 1;

          this.proposal.companyNationalId ? progress++ : 1;
        }
        if (this.proposal.companyId == this.notCompany) {
          this.proposal.otherCompanyName ? progress++ : 1;

          this.proposal.otherCompanyRegistrationNumber ? progress++ : 1;

          this.proposal.otherCompanyNationalId ? progress++ : 1;
        }
        this.proposal.companyProducts ? progress++ : 1;
        this.proposal.companyContactInfo ? progress++ : 1;
        this.proposal.letterCompanyFileId ? progress++ : 1;
        progress =
          this.proposal.companyId != this.notCompany
            ? parseInt((progress / 12) * 100)
            : parseInt((progress / 14) * 100);
      } else if (this.proposal.commercializingType == "accelerator") {
        this.proposal.acceleratorId ? progress++ : 1;

        progress = parseInt((progress / 9) * 100);
      } else if (this.proposal.commercializingType == "none") {
        this.proposal.commercializingObligation1 ? progress++ : 1;
        this.proposal.commercializingObligation2 ? progress++ : 1;
        this.reactivity = !this.reactivity;

        progress = parseInt((progress / 10) * 100);
      }

      return progress;
    },
    step6progress() {
      // NOTE (c-step6Progress) previous
      let progress = 0;
      let total = 1;

      if (this.proposal.gantData.length == 0) return 0;

      total += this.proposal.gantData.length * 4;

      this.proposal.gantData.forEach((x) => {
        x.description ? progress++ : 1;
        x.percent == 0 || x.percent ? progress++ : 1;
        x.startDate ? progress++ : 1;
        x.dueDate ? progress++ : 1;
      });

      this.proposal.gantData
        .map((x) => x.percent)
        .reduce((a, b) => Number(a) + Number(b), 0) == 100
        ? progress++
        : 1;

      progress = parseInt((progress / total) * 100);
      return progress;
    },
    achievmentItemsClass() {
      let progress = 0;
      let total = 0; //default number of price variables due to last table

      if (this.proposal.requestProducts) {
        total += this.proposal.requestProducts.length * 3;
        this.proposal.requestProducts.forEach((x) => {
          x.name ? progress++ : 1;
          x.amount ? progress++ : 1;
          x.fullfill ? progress++ : 1;
        });
        if (total / progress == 1) {
          return "done";
        } else {
          return "required";
        }
      } else {
        return "required";
      }
    },
    step7progress() {
      // NOTE (c-step7Progress) previous
      let progress = 0;
      let total = 0; //default number of price variables due to last table

      if (this.proposal.personnelCosts.length > 0) {
        total += this.proposal.personnelCosts.length * 5;
        this.proposal.personnelCosts.forEach((x) => {
          x.name ? progress++ : 1;
          x.degree ? progress++ : 1;
          x.cooperationType ? progress++ : 1;
          x.cooperationHour ? progress++ : 1;
          x.perPersonCost ? progress++ : 1;
        });
      }
      if (this.proposal.travelExpenses.length > 0) {
        total += this.proposal.travelExpenses.length * 4;
        this.proposal.travelExpenses.forEach((x) => {
          x.destination ? progress++ : 1;
          x.reason ? progress++ : 1;
          x.number ? progress++ : 1;
          // x.day ? progress++ : 1;
          x.cost ? progress++ : 1;
        });
      }
      if (this.proposal.purchases.length > 0) {
        total += this.proposal.purchases.length * 5;
        this.proposal.purchases.forEach((x) => {
          x.name ? progress++ : 1;
          // x.consumable ? progress++ : 1;
          // x.fund ? progress++ : 1;
          x.type ? progress++ : 1;
          x.source ? progress++ : 1;
          x.number ? progress++ : 1;
          x.perPrice ? progress++ : 1;
        });
      }

      if (this.proposal.participationOrganizationBudget.length > 0) {
        total += this.proposal.participationOrganizationBudget.length * 2;
        this.proposal.participationOrganizationBudget.forEach((x) => {
          x.name ? progress++ : 1;
          x.description ? progress++ : 1;
        });
      }

      // if (this.proposal.otherCosts.length > 0) {
      //   total += this.proposal.otherCosts.length * 3;
      //   this.proposal.otherCosts[0].totalPrice ? progress++ : 1;
      //   this.proposal.otherCosts[1].totalPrice ? progress++ : 1;
      //   this.proposal.otherCosts[2].totalPrice ? progress++ : 1;
      // }

      return total == 0 ? 0 : parseInt((progress / total) * 100);
    },
    step8progress() {
      // NOTE (c-step8Progress) previous
      let progress = 0;
      if (this.proposal.reviewers.length == 0) return 100;

      this.proposal.reviewers.forEach((x) => {
        x.name ? progress++ : 1;
        x.lastName ? progress++ : 1;
        x.expertise ? progress++ : 1;
        x.field ? progress++ : 1;
        x.lastDegree ? progress++ : 1;
        x.academicRank ? progress++ : 1;
        x.email && this.validateEmail(x.email) ? progress++ : 1;
        x.mobile ? progress++ : 1;
      });

      progress = parseInt(
        (progress / 8 / this.proposal.reviewers.length) * 100
      );
      return progress;
    },
    step9progress() {
      // NOTE (c-step9Progress) previous
      let progress = 0;
      this.proposal.letterUniversityResearchFileId ? progress++ : 1;


      return parseInt((progress) * 100);
    },
    step10progress() {
      // NOTE (c-step10Progress) previous
      let progress = 0;
      for (let i = 0; i < 12; i++) {
        this.proposal.promiseArrays[i] ? progress++ : 1;
      }
      return parseInt((progress / 12) * 100);
    },
    lastStepProgress() {
      // NOTE (c-lastStepProgress) previous
      let wholeSteps = 0;
      for (let i = 1; i <= 10; i++) {
        wholeSteps += this["step" + i + "progress"];
      }
      // x => (wholeSteps += this["step" + x + "progress"])

      return parseInt(wholeSteps / 10);
    },
    computedTitle1() {
      if (this.proposal.companyId) {
        if (this.proposal.companyId != this.notCompany) {
          return true;
        } else {
          if (this.proposal.otherCompanyRegistrationNumber) {
            return true;
          } else return false;
        }
      } else {
        return false;
      }
    },
    computedTitle2() {
      if (this.proposal.companyId) {
        if (this.proposal.companyId != this.notCompany) {
          return true;
        } else {
          if (this.proposal.otherCompanyNationalId) {
            return true;
          } else return false;
        }
      } else {
        return false;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.getStatesAndCities();
    this.onMounted();
  },
  updated() {},
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}

.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
.select-text {
  color: red;
}
</style>
